export const MERCURY_PACKAGE_TYPES = [
  {
      "guid": "5ad138ef-2493-4117-bf83-b76e4e5f609d",
      "uuid": "a1798e88-54f2-4cab-ac60-6c075fcce19f",
      "name": "Ампула, защищенная",
      "code": "AP"
  },
  {
      "guid": "1f9a9273-be63-4e4b-b29b-dfee1f0da370",
      "uuid": "752c6b66-c342-47c0-9fed-dd9a204d5332",
      "name": "Ампула, незащищенная",
      "code": "AM"
  },
  {
      "guid": "975160ee-6cb0-4501-a821-9e3574f09446",
      "uuid": "d14a94a6-2cda-420c-89a9-328951176011",
      "name": "Аэрозольная упаковка",
      "code": "AE"
  },
  {
      "guid": "ec29a5a8-17fa-480c-a1d5-333a4411e393",
      "uuid": "7541a5af-90a4-4492-8523-c4b345504b3a",
      "name": "Багаж",
      "code": "LE"
  },
  {
      "guid": "0f4cc0b5-af48-4571-a06b-96504ec89012",
      "uuid": "22eb54ac-885b-4c6a-a2cb-aedd8150de47",
      "name": "Бадья",
      "code": "BJ"
  },
  {
      "guid": "93bdc740-0f32-4019-a3fd-ed661f2bc3b9",
      "uuid": "d6748031-00cc-41e5-a5ae-351e1e1a811e",
      "name": "Бак",
      "code": "VA"
  },
  {
      "guid": "bc29f22a-6086-4438-acd2-1f40a3b00a66",
      "uuid": "3a9a7ae7-6ed4-44ce-8554-8aa5fc085e1b",
      "name": "Балка",
      "code": "GI"
  },
  {
      "guid": "491e8863-7850-4b06-8abc-52c09dd05d0d",
      "uuid": "f9f1091c-7980-4905-9a4e-4238c6830e8d",
      "name": "Балка в пакете/пачке/связке",
      "code": "GZ"
  },
  {
      "guid": "6a10e7ae-b8ff-4249-a23d-1dec8128c4a1",
      "uuid": "de7013a8-5f50-4f18-b623-57378f44cf6a",
      "name": "Баллон, газовый",
      "code": "GB"
  },
  {
      "guid": "0fdf7f98-6595-480b-8988-5544d8ff40b3",
      "uuid": "8393e5be-0e6f-4a36-a70d-408a6a9e32a9",
      "name": "Баллон, защищенный",
      "code": "BP"
  },
  {
      "guid": "49e8e70e-e539-4ce1-8d20-5a49ae276f77",
      "uuid": "c54dcb58-3197-4400-8ab1-13d4da58bcd4",
      "name": "Баллон, незащищенный",
      "code": "BF"
  },
  {
      "guid": "8a9c1190-aeeb-498d-8e80-5ddfbc3f7df2",
      "uuid": "a367dfab-fb7b-45c1-a8b3-bcaaa969b482",
      "name": "Бандероль",
      "code": "PC"
  },
  {
      "guid": "0cc66f67-3111-4e77-9dcc-c9a9df725bed",
      "uuid": "24383fcc-5151-4c54-9342-2dc6194a1a3f",
      "name": "Банка (емкостью менее 5 л) жестяная прямоугольная",
      "code": "CA"
  },
  {
      "guid": "18a67ab0-21a3-4e8c-9058-d8f42820938d",
      "uuid": "8a867654-c0cf-473f-b889-e1c56ecff4da",
      "name": "Банка (емкостью менее 5 л) жестяная с ручкой и выпускным отверстием",
      "code": "CD"
  },
  {
      "guid": "54ed0793-c32e-41c1-9321-608c1a224edc",
      "uuid": "1f61d7f8-e846-4f8e-8a3f-f95aea382539",
      "name": "Банка (емкостью менее 5 л) жестяная цилиндрическая",
      "code": "CX"
  },
  {
      "guid": "91f360ff-5731-4c1c-bf11-7ea3d6d1a3ca",
      "uuid": "1fafa987-5e45-4d98-9e29-12caea323ea1",
      "name": "Банка жестяная для сухих продуктов (массой до 2,2 кг)",
      "code": "CI"
  },
  {
      "guid": "c1f40234-bff1-42c8-8e19-d6cad7f00fce",
      "uuid": "052ac9af-5849-4fff-aa31-566ca7e07c5c",
      "name": "Банка широкогорлая (емкостью около 4,5 литров)",
      "code": "JR"
  },
  {
      "guid": "fedf422e-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "d6d59931-aac1-45fe-a144-933b91d48fa3",
      "name": "Банка, жестяная (консервная)",
      "code": "TN"
  },
  {
      "guid": "13f13e66-adf4-431a-9cff-22cfd839047b",
      "uuid": "38be3857-eb77-4e45-aac3-bde2864b4aca",
      "name": "Барабан",
      "code": "DR"
  },
  {
      "guid": "2e53354c-4023-434b-926f-bbdd1af00a37",
      "uuid": "a9b3e443-0bef-4eab-8787-06831c6178d9",
      "name": "Барабан алюминиевый с несъемным днищем",
      "code": "QC"
  },
  {
      "guid": "970e40fd-3436-48ed-ac99-e78802f57119",
      "uuid": "dd6ad151-3ccd-4d09-87de-056172f1038f",
      "name": "Барабан алюминиевый со съемным днищем",
      "code": "QD"
  },
  {
      "guid": "eec09740-2c4c-460b-94ed-c4d4ef437f1b",
      "uuid": "e4ebac83-3843-4bec-9277-1d4fe7f81afc",
      "name": "Барабан пластмассовый с несъемным днищем",
      "code": "QF"
  },
  {
      "guid": "d565dd82-5fc1-4303-a55d-495c35ac22ec",
      "uuid": "a310509f-ca8a-4079-8319-c220f4758400",
      "name": "Барабан пластмассовый со съемным днищем",
      "code": "QG"
  },
  {
      "guid": "02f1c682-8f53-47f8-b8dc-72404d986e66",
      "uuid": "9ddf31ea-9c4b-499b-81a5-417a13510ab7",
      "name": "Барабан стальной",
      "code": "1A"
  },
  {
      "guid": "c113fb0c-23eb-4ce5-ad44-8250598f173e",
      "uuid": "519d65e0-b6c1-4e6a-8da7-a48bf457e1da",
      "name": "Барабан стальной с несъемным днищем",
      "code": "QA"
  },
  {
      "guid": "1852b14d-39a0-4712-9e55-90a7005d5469",
      "uuid": "424c3b70-22f8-4dcd-913a-c19b49ce765f",
      "name": "Барабан стальной со съемным днищем",
      "code": "QB"
  },
  {
      "guid": "e5f7f98d-6a9c-4866-8cac-4819f71e41b3",
      "uuid": "a091c309-5510-4665-8f97-711adba75fac",
      "name": "Барабан фанерный",
      "code": "1D"
  },
  {
      "guid": "6bf25be3-0cf7-4dd8-a383-049a02862968",
      "uuid": "c797d606-3c58-45e2-bae1-43eb721ef85d",
      "name": "Барабан фибровый",
      "code": "1G"
  },
  {
      "guid": "ed90911b-d130-4d3b-ae0b-2f0754d23fd4",
      "uuid": "db0c6b94-55b0-4513-b93d-3e002bb25633",
      "name": "Барабан, алюминиевый",
      "code": "1B"
  },
  {
      "guid": "0ef53349-5258-4efc-ac2a-23d1e33f387b",
      "uuid": "808742a1-03e3-463f-9dac-e7da65910f19",
      "name": "Барабан, деревянный",
      "code": "1W"
  },
  {
      "guid": "bbe136bd-0da4-42fd-800a-79435f4dd2c0",
      "uuid": "3e801607-351e-4654-8eb7-20e6f7ac99e4",
      "name": "Барабан, железный",
      "code": "DI"
  },
  {
      "guid": "dd7c7ba0-dbc3-435d-94f7-5b758ca36898",
      "uuid": "6985abdd-7aba-4590-a345-f024c287a71b",
      "name": "Барабан, пластмассовый",
      "code": "IH"
  },
  {
      "guid": "ae0b5e58-8771-48f7-8c3c-11dfdb17ebad",
      "uuid": "91f15d01-88f0-47e5-98cc-2e1679bdd212",
      "name": "Без клети",
      "code": "UC"
  },
  {
      "guid": "34e245a7-cd7c-4d8b-a436-482dcbcf1f38",
      "uuid": "8eb7fa55-7b61-4880-8100-dc8d907425a3",
      "name": "Бидон",
      "code": "CC"
  },
  {
      "guid": "41e9ff79-b6c4-46e7-a2d4-6f5bf3ee1002",
      "uuid": "5e80ee1e-5ce8-4fde-ad0c-b81f0ac91f86",
      "name": "Бобина",
      "code": "BB"
  },
  {
      "guid": "fedf412a-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "6548a901-8c41-456d-82fd-f4f6808ec473",
      "name": "Бочка",
      "code": "CK"
  },
  {
      "guid": "3630beae-fe03-49ff-9264-93925ca7ce80",
      "uuid": "3481b7ad-7f3b-451b-80c6-b32b14faa5b5",
      "name": "Бочка (емкостью около 164 л)",
      "code": "BA"
  },
  {
      "guid": "5623e14a-903b-48e4-8afa-07db65991173",
      "uuid": "db331559-de47-4e2f-b9ff-14e162d79aa5",
      "name": "Бочка (емкостью около 164 л) деревянная",
      "code": "2C"
  },
  {
      "guid": "3c78e2e1-d19a-40d3-b970-4fe6d2b722d0",
      "uuid": "0f2c027f-b007-4857-babf-06c9bf658346",
      "name": "Бочка (емкостью около 164 л) деревянная со съемным днищем",
      "code": "QJ"
  },
  {
      "guid": "021bc2d9-f514-4491-b21a-ffe63023236f",
      "uuid": "1472c588-6342-4b4c-983b-93cf3847f2e6",
      "name": "Бочка (емкостью около 164 л) деревянная шпунтованная",
      "code": "QH"
  },
  {
      "guid": "37495e99-e19f-4221-97e8-39565c0192b8",
      "uuid": "2546fe09-f832-46ed-83c4-0046a23ffc8a",
      "name": "Бочка деревянная (емкостью около 200 л)",
      "code": "TI"
  },
  {
      "guid": "c8066a6e-5f19-4429-85e1-9b2df548afa1",
      "uuid": "411f9741-2161-43e7-9857-0a44b7955847",
      "name": "Бочка для вина или пива",
      "code": "BU"
  },
  {
      "guid": "f1d48fb7-8536-4b99-8668-bd6a55167306",
      "uuid": "75d3649e-cf4e-4b67-9c2d-b8c73f855e25",
      "name": "Бочка для вина или пива большая (емкостью около 1146 л) (тан)",
      "code": "TO"
  },
  {
      "guid": "6583f8bf-8317-4ba4-bf4b-fafcd1d13bc1",
      "uuid": "c0b2a5f1-b570-4aec-8ed6-796d1faca271",
      "name": "Бочка емкостью 238 л (хогсхед)",
      "code": "HG"
  },
  {
      "guid": "8915e7eb-4f39-48aa-8171-7a629c95b69e",
      "uuid": "5de54132-e9d4-4755-9978-a32c57d83115",
      "name": "Бочонок (емкостью около 41 л)",
      "code": "FI"
  },
  {
      "guid": "8fe0727a-b2ed-4040-9df5-a14e4ad7f6a8",
      "uuid": "1bb17069-0744-435a-a5ea-102211dc97f0",
      "name": "Бочонок (емкостью около 46 л)",
      "code": "KG"
  },
  {
      "guid": "07f35ce7-6d5a-49e7-a7e2-659b6cf74def",
      "uuid": "70157b1b-c036-42d9-b173-5ad267ad9c01",
      "name": "Бревно",
      "code": "LG"
  },
  {
      "guid": "0e0ccdf4-8779-4d65-84e2-d9e689314630",
      "uuid": "cdccf228-a3d8-43cf-a253-7a0a2196539e",
      "name": "Бревно в пакете/пачке/связке",
      "code": "LZ"
  },
  {
      "guid": "d9afec35-b224-404f-a3ff-74a0496c128d",
      "uuid": "acfc366e-06d3-40b1-bd31-db3528f05adc",
      "name": "Брезент",
      "code": "CZ"
  },
  {
      "guid": "0ed01082-9c8e-49fa-8ba4-a91879d4b192",
      "uuid": "2c56f044-9d6a-496c-b12f-fef8062e5ecc",
      "name": "Брус (брусок)",
      "code": "BR"
  },
  {
      "guid": "086a3064-ab16-4d38-a7fa-3a28ee66b58b",
      "uuid": "3be96376-0920-4eb7-aafa-7632b323153c",
      "name": "Брус (брусок) в пакете/пачке/связке",
      "code": "BZ"
  },
  {
      "guid": "d2ed24d1-c72a-4dc6-b3a8-ff8ca179c5c4",
      "uuid": "bf8357f5-ba69-4e70-8ec5-4fe6fe72e4c8",
      "name": "Бункер",
      "code": "BI"
  },
  {
      "guid": "a23634f3-9e71-4c80-abc5-e4c77ac70c88",
      "uuid": "57002b4a-1af0-40a0-81fd-1a94e79764b6",
      "name": "Бутылка оплетенная",
      "code": "WB"
  },
  {
      "guid": "f7183d0a-5cee-4de8-9d08-bd5c7512ea7c",
      "uuid": "d273b7da-7db1-4785-87b4-fa9864a742d3",
      "name": "Бутылка с выпуклыми стенками защищенная",
      "code": "BV"
  },
  {
      "guid": "883a32f4-984e-43c1-8e03-ad02929cbfe4",
      "uuid": "b5e0456a-1c06-4cf2-a2c6-1c13696a031c",
      "name": "Бутылка с выпуклыми стенками незащищенная",
      "code": "BS"
  },
  {
      "guid": "9adfe441-f411-4fcc-9568-8274ec2a0697",
      "uuid": "c5475a8a-e3f1-4f8c-bfd4-ae4735e72713",
      "name": "Бутылка цилиндрическая защищенная",
      "code": "BQ"
  },
  {
      "guid": "1b986c7e-dcff-452f-b9c5-bc47afa6ccdc",
      "uuid": "99f619de-c036-4cc8-be25-8637a2b3a221",
      "name": "Бутылка цилиндрическая незащищенная",
      "code": "BO"
  },
  {
      "guid": "3e311a74-00dd-4554-b656-748aa45cc069",
      "uuid": "c44c92da-0cab-4ed7-8695-91602d9e581a",
      "name": "Бутыль оплетенная большая (емкостью от 9 до 54 л) защищенная",
      "code": "DP"
  },
  {
      "guid": "b654b00e-7601-408e-b059-783ab0371b35",
      "uuid": "afab7930-45df-4b87-9213-70270bd3b72a",
      "name": "Бутыль оплетенная большая (емкостью от 9 до 54 л) незащищенная",
      "code": "DJ"
  },
  {
      "guid": "fc881dea-5868-43ea-8b84-768aad44bc39",
      "uuid": "6e876337-5bd6-4649-ab3b-b44d84c2c3aa",
      "name": "Бутыль оплетенная защищенная",
      "code": "CP"
  },
  {
      "guid": "f8552b0c-1de2-4509-8de9-06284d01bdff",
      "uuid": "c8182b44-6b47-43ce-bf4e-86e5b538b12a",
      "name": "Бутыль оплетенная незащищенная",
      "code": "CO"
  },
  {
      "guid": "87cff419-7bd1-4a2a-b52e-3f6c358138c8",
      "uuid": "9f1dff8f-325c-42f0-a873-22ee33d74763",
      "name": "Бухта",
      "code": "CL"
  },
  {
      "guid": "04735711-516d-4331-92c6-b55e5f8e3710",
      "uuid": "09252cbd-7d8f-444c-9138-10f0caac2621",
      "name": "В вакуумной упаковке",
      "code": "VP"
  },
  {
      "guid": "b49dbb7b-56b9-48e3-9fd3-74a328dbcea3",
      "uuid": "841291b9-844e-421b-a729-5298417f92b8",
      "name": "В термоусадочной пленке",
      "code": "SW"
  },
  {
      "guid": "165fd412-0bfa-4bb5-8993-bcfaa5d82e1b",
      "uuid": "f5e7511e-6448-4ff6-8430-779f4c4b3eb4",
      "name": "Ведро",
      "code": "PL"
  },
  {
      "guid": "657fad4d-71a4-4939-90a4-3fb0c9aea7f7",
      "uuid": "4a89e444-c612-4dc2-a7e3-8e994313c714",
      "name": "Гильза",
      "code": "SY"
  },
  {
      "guid": "a423d25a-2a14-40b8-bf13-f6a85b8fc887",
      "uuid": "9ab1e3cf-6e22-4e51-91c6-86553c4d763e",
      "name": "Гнездо (ячейка)",
      "code": "NS"
  },
  {
      "guid": "4a7ea673-c3ac-40b5-836f-cfdd066b8020",
      "uuid": "20200df8-afa0-4442-bcc3-3a2974ab03b7",
      "name": "Горшок",
      "code": "PT"
  },
  {
      "guid": "668e236b-70b0-4afc-8ab3-3fb9335f909e",
      "uuid": "833297b2-cb98-4881-9ec6-0714343c21a6",
      "name": "Грейферный ковш",
      "code": "AI"
  },
  {
      "guid": "17f78e53-8978-4b58-9be5-d919c049a239",
      "uuid": "4aadf738-c12f-4845-94ec-1f6f38df8a89",
      "name": "Гроб",
      "code": "CJ"
  },
  {
      "guid": "d2612f44-ca2a-4146-986d-6650e6fe9194",
      "uuid": "47bdaa2c-06ba-41f5-9e3e-c591bac1834c",
      "name": "Грузовая партия (лот)",
      "code": "LT"
  },
  {
      "guid": "af4d4677-3ea7-46ba-9fe0-504ba81ebea7",
      "uuid": "4331bfb8-4a3e-41f8-be13-47fced880a9e",
      "name": "Дозатор",
      "code": "DN"
  },
  {
      "guid": "b8d3ee58-c120-4c4e-bd31-0e1d3451f5de",
      "uuid": "65064eae-e4fc-401d-9d83-b6acdcac8fb0",
      "name": "Доска",
      "code": "BD"
  },
  {
      "guid": "c84cb473-a0cc-4433-8b56-c7beb88fc59b",
      "uuid": "4f6d1357-a57d-44df-aa0e-d22d6e7daf59",
      "name": "Доска в пакете/пачке/связке",
      "code": "BY"
  },
  {
      "guid": "3dca7c38-3a10-4fb6-9c1f-0c64ab79d63b",
      "uuid": "10f09b3d-ce70-4084-83f3-1b2d7a7fa6c9",
      "name": "Доска толстая в пакете/пачке/связке",
      "code": "PZ"
  },
  {
      "guid": "4d5772a0-9fa4-47ab-8c32-9a07729740ad",
      "uuid": "715b627a-bb3c-4178-896d-72b59367ae8a",
      "name": "Доска, толстая",
      "code": "PN"
  },
  {
      "guid": "5e5f4afb-d5f8-483a-999e-cb985af7580b",
      "uuid": "72276339-fc12-473d-ba5a-002983cf5252",
      "name": "Единица",
      "code": "UN"
  },
  {
      "guid": "207dccd8-7a12-44c3-a77b-7dd945a7b0bd",
      "uuid": "c05fc063-a894-4383-968f-d4e15b6a65b3",
      "name": "Кадка",
      "code": "TB"
  },
  {
      "guid": "6046383e-9e59-40bc-a70b-a0538ef536ca",
      "uuid": "fccdc8f9-1033-474a-aa86-fb85aca7aeff",
      "name": "Кадка с крышкой",
      "code": "TL"
  },
  {
      "guid": "4d9bd778-5ce4-411c-8d78-a1959ac55590",
      "uuid": "ff1553fa-d152-4c39-b5d8-3b39d3baca83",
      "name": "Канистра пластмассовая с несъемным днищем",
      "code": "QM"
  },
  {
      "guid": "ba61904f-f946-448a-958b-518655d8f567",
      "uuid": "f3d81ca8-e7e0-4e26-8914-dbbfca60ce31",
      "name": "Канистра пластмассовая со съемным днищем",
      "code": "QN"
  },
  {
      "guid": "a2110164-70b4-49f6-afaa-f3abde1be0f1",
      "uuid": "f79b427d-b727-48c5-baa3-1fc6f23f371e",
      "name": "Канистра стальная с несъемным днищем",
      "code": "QK"
  },
  {
      "guid": "72896fbf-b156-4c7b-868d-ac13c5a85c7e",
      "uuid": "dd0c70d8-4aea-4a26-a476-5cb20fc79ad3",
      "name": "Канистра стальная со съемным днищем",
      "code": "QL"
  },
  {
      "guid": "12829e8e-7983-4745-8d01-5425d0244df6",
      "uuid": "b7fe7ffe-c6e3-4a5b-8b15-fbd0e8e50cba",
      "name": "Канистра, пластмассовая",
      "code": "3H"
  },
  {
      "guid": "a17e05ea-2fd6-485f-8db6-5aed1606f851",
      "uuid": "64b123f2-50c7-4714-926d-0a9c4d769c5f",
      "name": "Канистра, прямоугольная",
      "code": "JC"
  },
  {
      "guid": "315646b0-01b2-4728-ab20-39911b080c26",
      "uuid": "018450a1-9dab-4faf-9e07-5397be1a40e2",
      "name": "Канистра, стальная",
      "code": "3A"
  },
  {
      "guid": "a7eb10cf-5a71-4cd2-97eb-c7369a407ccf",
      "uuid": "73a0cfed-91eb-44f4-8b2a-e0273b34687d",
      "name": "Канистра, цилиндрическая",
      "code": "JY"
  },
  {
      "guid": "8bcdee71-cca5-4536-ae2e-8a423d7dab60",
      "uuid": "ab91d666-6070-472b-b1e9-2c233efc9a8b",
      "name": "Капсула",
      "code": "AV"
  },
  {
      "guid": "0f402761-1d53-45dc-9566-d709cd1ccb4d",
      "uuid": "4f1a8ccd-5e9e-4c75-82e0-e7f5202d0bec",
      "name": "Кардная лента",
      "code": "CM"
  },
  {
      "guid": "8211a6d5-11ea-4a5e-96dd-b52c3fe0a801",
      "uuid": "9e14f974-1006-4f9f-bc13-642697090e51",
      "name": "Кассета",
      "code": "CQ"
  },
  {
      "guid": "c7ee807d-56a9-47c5-95d7-72021f303167",
      "uuid": "ad477afb-e10c-49a4-a379-1b1b96323328",
      "name": "Кассета с пленкой (фильмпак)",
      "code": "FP"
  },
  {
      "guid": "4b3478b2-bd43-4fe1-85bd-77a457a1cd72",
      "uuid": "91a25b6d-fac1-4e9a-b7d7-f03466dd635a",
      "name": "Катушка",
      "code": "RL"
  },
  {
      "guid": "31ff0ebc-8b93-4ab4-9e6f-04dcab641eb2",
      "uuid": "69a0a352-2eba-462a-aee7-9be669fa4081",
      "name": "Кипа, неспрессованная",
      "code": "BN"
  },
  {
      "guid": "90ae449d-76c3-47a2-a0ec-39febdc0c965",
      "uuid": "417e2161-637b-4ca2-bc63-f37395e33b0b",
      "name": "Кипа, спрессованная",
      "code": "BL"
  },
  {
      "guid": "6da6c216-abc1-4534-825c-821a41b2dbc2",
      "uuid": "186f1a9c-c1ee-487c-b3a8-0d6baa6b446d",
      "name": "Клеть",
      "code": "CG"
  },
  {
      "guid": "09f4ec10-6101-4c3d-b57a-251aa11e7752",
      "uuid": "d1283209-c059-4f57-a4b2-573bcaa8e590",
      "name": "Клеть (многооборотная) Общего фонда транспортировочного оборудования EC",
      "code": "DG"
  },
  {
      "guid": "4770cd27-c22b-4da6-bba5-c69dcd601b74",
      "uuid": "7c83a5f7-6d4f-4130-9f7c-86bc35c26f45",
      "name": "Клеть, роликовая",
      "code": "CW"
  },
  {
      "guid": "538f0705-e05d-4154-bfb5-0e63ab30122b",
      "uuid": "9b2feac0-1578-4847-88c0-36f59b5e3aba",
      "name": "Кольцо",
      "code": "RG"
  },
  {
      "guid": "d0416c04-368d-48bf-b5fb-d3fe21f3977c",
      "uuid": "1343c3ad-605f-4734-a94f-61b2e756e6af",
      "name": "Комбинированная упаковка: пластмассовый сосуд",
      "code": "6H"
  },
  {
      "guid": "858efe47-f7d6-4f6e-9408-79b8e3d9ae83",
      "uuid": "162e3d68-da22-462e-a66f-40d825e8e35d",
      "name": "Комбинированная упаковка: пластмассовый сосуд в барабане алюминиевом",
      "code": "YC"
  },
  {
      "guid": "b95eb3b6-d08a-441e-9a3a-6d3f9501cc99",
      "uuid": "d6dff8ee-2128-4953-8a5b-655de46a920b",
      "name": "Комбинированная упаковка: пластмассовый сосуд в барабане пластмассовом",
      "code": "YL"
  },
  {
      "guid": "6b8efc02-9611-451c-b215-503bc29301cd",
      "uuid": "e44a943e-ca15-4cf3-9710-6d7ae49b241c",
      "name": "Комбинированная упаковка: пластмассовый сосуд в барабане стальном",
      "code": "YA"
  },
  {
      "guid": "21246938-dd6f-49aa-8e2a-d1cb13b0be17",
      "uuid": "268f0297-d439-4d5f-a908-2289b28dc0cf",
      "name": "Комбинированная упаковка: пластмассовый сосуд в барабане фибровом",
      "code": "YJ"
  },
  {
      "guid": "05e4976b-9504-44ac-8645-06bf6a24ad59",
      "uuid": "2e8abf12-6444-4d4d-b85a-92f6d546fb9f",
      "name": "Комбинированная упаковка: пластмассовый сосуд в деревянной коробке",
      "code": "YF"
  },
  {
      "guid": "5e8755cb-a874-499d-bb4d-34e465df0978",
      "uuid": "57a29f62-1c63-4f53-bddd-1c8d526d2e06",
      "name": "Комбинированная упаковка: пластмассовый сосуд в коробке из твердой пластмассы",
      "code": "YM"
  },
  {
      "guid": "eb55f088-06cc-4bab-9f84-49f2f999f428",
      "uuid": "03b6d676-7540-4451-b2c2-3e2fb72a2862",
      "name": "Комбинированная упаковка: пластмассовый сосуд в коробке из фибрового картона",
      "code": "YK"
  },
  {
      "guid": "ab579955-759f-4de1-b8b9-460ad80facfb",
      "uuid": "ff2bf99c-3f33-4405-8672-60bfea345eef",
      "name": "Комбинированная упаковка: пластмассовый сосуд в коробке фанерной",
      "code": "YH"
  },
  {
      "guid": "95307257-321c-4dd1-9a30-e30cbcffcfb1",
      "uuid": "7eaec820-b340-4ff5-86b0-febaf8006db1",
      "name": "Комбинированная упаковка: пластмассовый сосуд в ящике решетчатом (или обрешетке) из алюминия",
      "code": "YD"
  },
  {
      "guid": "43c6ad00-832f-42c6-8e2a-fe2273814b66",
      "uuid": "ae7cb033-e5a0-46c3-8173-c12f1e868e24",
      "name": "Комбинированная упаковка: пластмассовый сосуд в ящике решетчатом (или обрешетке) из стали",
      "code": "YB"
  },
  {
      "guid": "380c561e-749a-4408-88de-ad5399c8a53f",
      "uuid": "fc68e8a2-415c-48c6-9cc3-724ab15c528d",
      "name": "Комбинированная упаковка: стеклянный сосуд",
      "code": "6P"
  },
  {
      "guid": "2e460cc7-7c38-4bf4-aa19-7768cb14d234",
      "uuid": "696b556b-fd32-4b05-83e8-1730c64ff476",
      "name": "Комбинированная упаковка: стеклянный сосуд в барабане алюминиевом",
      "code": "YQ"
  },
  {
      "guid": "fa1d17e8-e12d-4544-9461-db80f49cfe4b",
      "uuid": "2d0b13ac-f110-457e-880b-d74898e3cc52",
      "name": "Комбинированная упаковка: стеклянный сосуд в барабане фанерном",
      "code": "YT"
  },
  {
      "guid": "40c8a0db-74c9-4190-9449-6f3f8ac2eaa7",
      "uuid": "fd4f0952-281d-4128-988c-cc180002627b",
      "name": "Комбинированная упаковка: стеклянный сосуд в барабане фибровом",
      "code": "YW"
  },
  {
      "guid": "32936c38-e9fa-439b-8108-5b7e3c482f6c",
      "uuid": "a8a2fb28-c4eb-48d9-b752-bd21d41004e5",
      "name": "Комбинированная упаковка: стеклянный сосуд в корзине плетеной с крышкой",
      "code": "YV"
  },
  {
      "guid": "4195a944-7c45-44e9-9cf9-d366386ad86e",
      "uuid": "9ef685c4-2901-4400-8c62-8b6d811d015b",
      "name": "Комбинированная упаковка: стеклянный сосуд в коробке деревянной",
      "code": "YS"
  },
  {
      "guid": "eabbfb7f-b3ea-4858-981a-201a18be8a0a",
      "uuid": "0984f9df-c2e2-4a8b-a89e-bbe5de256287",
      "name": "Комбинированная упаковка: стеклянный сосуд в коробке из фибрового картона",
      "code": "YX"
  },
  {
      "guid": "5a349e4c-ce4c-485e-81db-beec4aa09fa4",
      "uuid": "11ee1e03-0553-4017-b936-59b80de341ea",
      "name": "Комбинированная упаковка: стеклянный сосуд в пакете из твердой пластмассы",
      "code": "YZ"
  },
  {
      "guid": "ce9f36bf-2f90-424c-b34f-e8715dd15e02",
      "uuid": "29414686-c50c-4a77-9e5c-42477548b8fa",
      "name": "Комбинированная упаковка: стеклянный сосуд в пакете пенопластовом",
      "code": "YY"
  },
  {
      "guid": "57eeeadf-7c4b-4614-9731-6e47d4b273a9",
      "uuid": "2377c4b2-9949-420e-8363-8455abe22da7",
      "name": "Комбинированная упаковка: стеклянный сосуд в стальном барабане",
      "code": "YN"
  },
  {
      "guid": "6355c3ee-6d1c-4bc5-a6ff-2a808274f222",
      "uuid": "556bd077-2443-45cd-bacf-d67ab1969864",
      "name": "Комбинированная упаковка: стеклянный сосуд в ящике решетчатом (или обрешетке) из алюминия",
      "code": "YR"
  },
  {
      "guid": "5893d315-48c8-49f7-9dc4-2dde43e090b9",
      "uuid": "bb00a68c-3a93-4e84-bca2-d69d6ddb1b12",
      "name": "Комбинированная упаковка: стеклянный сосуд в ящике решетчатом (или обрешетке) из стали",
      "code": "YP"
  },
  {
      "guid": "b5cd2c76-152f-4d8f-a5c2-d196dd920426",
      "uuid": "7c25b7ed-4444-4417-9c6f-6d51e917e32e",
      "name": "Комплект",
      "code": "SX"
  },
  {
      "guid": "3cb38979-51da-44a5-8bdc-8f549bb0aa68",
      "uuid": "f88ac7e2-3854-44ea-a221-0e0ce4c29e4b",
      "name": "Конверт",
      "code": "EN"
  },
  {
      "guid": "dddd429e-0376-4030-bb9e-2ad9cba0f3c4",
      "uuid": "16201743-1e09-4cc0-be29-e24380e527a1",
      "name": "Конверт, стальной",
      "code": "SV"
  },
  {
      "guid": "d90e17f4-8bed-46be-a1d1-9bb7f0f4d736",
      "uuid": "2b120941-8c11-4bde-a669-4b69bec21abc",
      "name": "Консоль для оборудования, помещающаяся в минифургон",
      "code": "VK"
  },
  {
      "guid": "5d753d93-c512-4f55-8fc8-0c0f1461d6a0",
      "uuid": "fcf8b58e-b821-4ee0-b70d-d8ea59612cc9",
      "name": "Контейнер для пищевых продуктов",
      "code": "FT"
  },
  {
      "guid": "9ef6b142-22e7-4a1c-bc5f-7945dc5a654f",
      "uuid": "f937b0bb-321a-4bae-b848-ab8e808c8df1",
      "name": "Контейнер металлический",
      "code": "ME"
  },
  {
      "guid": "d273dbfd-c8ed-4637-9ad2-5e40d7ecbf3a",
      "uuid": "a48d2f90-dac2-43f0-b61c-13e7616cd8b7",
      "name": "Контейнер наружный",
      "code": "OU"
  },
  {
      "guid": "fedf606a-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "8ca28fd5-a0b7-4b6c-b2a8-84cfdda442d4",
      "name": "Контейнер средней грузоподъемности для массовых грузов",
      "code": "WA"
  },
  {
      "guid": "b86afba4-7492-4910-b266-6ab67235095c",
      "uuid": "be2ad8ab-3f32-47f0-92e9-001c61462ad5",
      "name": "Контейнер средней грузоподъемности для массовых грузов алюминиевый",
      "code": "WD"
  },
  {
      "guid": "6505c314-3e58-496e-becc-9ee71c08eacc",
      "uuid": "98fce7c0-4bab-4366-9b6d-7066512e945d",
      "name": "Контейнер средней грузоподъемности для массовых грузов алюминиевый герметизированный свыше 10 КПа",
      "code": "WH"
  },
  {
      "guid": "caeda84d-f591-4ca8-888f-2b0857d6d66a",
      "uuid": "f75e07be-5795-48ad-98f6-fdf7a462d2d1",
      "name": "Контейнер средней грузоподъемности для массовых грузов бумажный многослойный",
      "code": "ZA"
  },
  {
      "guid": "566c12fc-5fc1-4189-8fc4-f4ff072c4897",
      "uuid": "928a9898-5f19-49bb-a6c0-17fa10bf4e37",
      "name": "Контейнер средней грузоподъемности для массовых грузов бумажный многослойный влагонепроницаемый",
      "code": "ZC"
  },
  {
      "guid": "800fc586-864c-4c29-ae15-d0d405e5d82a",
      "uuid": "f58f9a0f-26df-412d-9f59-864a83e84a65",
      "name": "Контейнер средней грузоподъемности для массовых грузов герметизированный 10 Кпа",
      "code": "WJ"
  },
  {
      "guid": "3a762c62-7b9e-4ccc-95e7-50fed26da877",
      "uuid": "8b7bdbd6-8d89-43bf-8c48-8fc1718e40b0",
      "name": "Контейнер средней грузоподъемности для массовых грузов герметизированный свыше 10 КПа",
      "code": "WG"
  },
  {
      "guid": "1061b465-9f46-48ba-8939-e4e14afd6270",
      "uuid": "321041ef-8368-4840-a1a4-d980c291341a",
      "name": "Контейнер средней грузоподъемности для массовых грузов гибкий",
      "code": "ZU"
  },
  {
      "guid": "e143c99a-f5c3-4e66-a50b-52a5cabc6325",
      "uuid": "54be0f7a-47d8-4f56-8e05-064ae9098d28",
      "name": "Контейнер средней грузоподъемности для массовых грузов из древесного материала",
      "code": "ZY"
  },
  {
      "guid": "828064d7-80be-4ba4-a13c-7a17476e763e",
      "uuid": "d3b6101b-563b-48e3-9aae-6afbca2bd1c0",
      "name": "Контейнер средней грузоподъемности для массовых грузов из древесного материала с внутренним вкладышем",
      "code": "WZ"
  },
  {
      "guid": "057ea6ec-aab1-4e2c-be58-f976fd3bbb37",
      "uuid": "0bc6bfa5-bb67-418b-a3f1-35f1c940d323",
      "name": "Контейнер средней грузоподъемности для массовых грузов из естественной древесины",
      "code": "ZW"
  },
  {
      "guid": "c5f0a52e-2496-45f0-9c5d-0cca7c1643a1",
      "uuid": "64a452ae-05eb-4570-b326-f7d15d7a1e0a",
      "name": "Контейнер средней грузоподъемности для массовых грузов из естественной древесины с внутренним вкладышем",
      "code": "WU"
  },
  {
      "guid": "5cea30bc-bd13-4c2a-af79-90a2e1804b07",
      "uuid": "bab6db9b-b979-43e1-868c-f3e95d38efea",
      "name": "Контейнер средней грузоподъемности для массовых грузов из жесткой пластмассы",
      "code": "AA"
  },
  {
      "guid": "e729238b-88ff-4991-a67e-8ec66cded23c",
      "uuid": "42735a40-1c9b-429a-8f32-b8fe483c716a",
      "name": "Контейнер средней грузоподъемности для массовых грузов из жесткой пластмассы автономный герметизированный",
      "code": "ZH"
  },
  {
      "guid": "2b58bc8f-b007-4ef4-808b-a4eedc9df54c",
      "uuid": "15efd241-05f9-40e3-958a-94d15dc41e5d",
      "name": "Контейнер средней грузоподъемности для массовых грузов из жесткой пластмассы с конструкционным оснащением герметизированный",
      "code": "ZG"
  },
  {
      "guid": "c159513f-dcf5-4402-ab16-8a1970e7b9d4",
      "uuid": "b4d0f13e-7810-421e-94ea-45bed459308c",
      "name": "Контейнер средней грузоподъемности для массовых грузов из пластикового волокна с покрытием и вкладышем",
      "code": "WR"
  },
  {
      "guid": "92765566-620c-4877-a58f-4107c3c6d468",
      "uuid": "de837f74-8090-47fa-8801-2e7ca014c203",
      "name": "Контейнер средней грузоподъемности для массовых грузов из полимерной пленки",
      "code": "WS"
  },
  {
      "guid": "9c415e68-6f34-4e5c-81c2-696e994a77cc",
      "uuid": "4d18320f-a0ff-4245-8846-de147e9240ee",
      "name": "Контейнер средней грузоподъемности для массовых грузов из полимерной ткани без покрытия/вкладыша",
      "code": "WN"
  },
  {
      "guid": "fed6b6cb-60b7-4df5-b81e-37b7a2b2a24e",
      "uuid": "6e0fea7e-b905-4af2-b600-4b2c3c62c721",
      "name": "Контейнер средней грузоподъемности для массовых грузов из полимерной ткани с вкладышем",
      "code": "WQ"
  },
  {
      "guid": "3d3bf9e3-12bb-4f0c-82ab-c79df71fcfdf",
      "uuid": "f1f308ed-a779-4763-8cfb-cf2e4e0a089e",
      "name": "Контейнер средней грузоподъемности для массовых грузов из полимерной ткани с покрытием",
      "code": "WP"
  },
  {
      "guid": "778afe34-03a9-4255-89ce-78229c9d233c",
      "uuid": "2bf1bf74-fd5e-4bff-a2f1-c0206f4daca0",
      "name": "Контейнер средней грузоподъемности для массовых грузов из прочего металла, кроме стали",
      "code": "ZV"
  },
  {
      "guid": "5a86d172-8b82-4992-b88c-8b1f80765ff5",
      "uuid": "41200c2a-cfa9-4231-bb84-0bb7c2dfd6f3",
      "name": "Контейнер средней грузоподъемности для массовых грузов из фибрового картона",
      "code": "ZT"
  },
  {
      "guid": "769f3e00-3bc6-4b59-b201-8972cd649ccc",
      "uuid": "fee11ffd-c372-4bc7-8bde-ff0a5b15280f",
      "name": "Контейнер средней грузоподъемности для массовых грузов металлический",
      "code": "WF"
  },
  {
      "guid": "fab06db6-977d-48df-8822-fb5ef954434c",
      "uuid": "cae0f975-4c9c-4d84-b60b-3cbfc8907743",
      "name": "Контейнер средней грузоподъемности для массовых грузов составной",
      "code": "ZS"
  },
  {
      "guid": "a3ee4967-a24f-4815-8f07-9d49ffe1de53",
      "uuid": "1866a193-ba12-4c8c-ae5a-26e34764db3a",
      "name": "Контейнер средней грузоподъемности для массовых грузов составной из гибкой пластмассы герметизированный",
      "code": "ZP"
  },
  {
      "guid": "fee9277d-adb9-4af6-aae9-3117412de104",
      "uuid": "488796c9-d954-487f-863f-9580ef84ed9b",
      "name": "Контейнер средней грузоподъемности для массовых грузов составной из жесткой пластмассы герметизированный",
      "code": "ZN"
  },
  {
      "guid": "a14e9f47-e745-4fb5-861e-642b8da576d9",
      "uuid": "ac06b1b2-02e3-49ae-9950-634a83b27623",
      "name": "Контейнер средней грузоподъемности для массовых грузов стальной",
      "code": "WC"
  },
  {
      "guid": "cb247727-4eaf-49dd-85cf-6e2dd7f2a3ab",
      "uuid": "4dcd6513-d10a-46de-91fa-3b36f49a49ae",
      "name": "Контейнер средней грузоподъемности для массовых грузов текстильный без покрытия/вкладыша",
      "code": "WT"
  },
  {
      "guid": "5c416509-50d7-464b-9455-9439604c2479",
      "uuid": "2f7e8d93-6cec-4956-be7f-94bb1573ff5b",
      "name": "Контейнер средней грузоподъемности для массовых грузов текстильный с вкладышем",
      "code": "WW"
  },
  {
      "guid": "111583f5-39e6-4b45-a941-b67d41ef4cae",
      "uuid": "d3991856-2828-45a7-9a20-a11f645759d7",
      "name": "Контейнер средней грузоподъемности для массовых грузов текстильный с покрытием",
      "code": "WV"
  },
  {
      "guid": "0d51ebba-b636-4a01-9a3a-e1f10fcc73df",
      "uuid": "33b7ab01-444e-401e-bcbf-db337b6ec78b",
      "name": "Контейнер средней грузоподъемности для массовых грузов текстильный с покрытием и вкладышем",
      "code": "WX"
  },
  {
      "guid": "6bc17666-63d7-49fd-9a82-fd98ff408dff",
      "uuid": "44966f37-fc2b-4331-a34f-841b3bb92ecc",
      "name": "Контейнер средней грузоподъемности для массовых грузов фанерный",
      "code": "ZX"
  },
  {
      "guid": "8015c596-6a81-40bc-bfca-f5961327bca4",
      "uuid": "e40819a3-0ae6-490c-8d35-3681ecac0bf7",
      "name": "Контейнер средней грузоподъемности для массовых грузов фанерный с внутренним вкладышем",
      "code": "WY"
  },
  {
      "guid": "a41e2a9a-d9f8-43f7-8781-15da3e5713d8",
      "uuid": "149911ee-5bfb-4554-b7c0-d702a93e25d1",
      "name": "Контейнер средней грузоподъемности для наливных грузов алюминиевый",
      "code": "WL"
  },
  {
      "guid": "4dfaab91-aacd-4a1b-a052-f40f873e6a46",
      "uuid": "4b1fbb1f-0a41-4cd5-915c-ceb602786f1a",
      "name": "Контейнер средней грузоподъемности для наливных грузов из жесткой пластмассы автономный",
      "code": "ZK"
  },
  {
      "guid": "5389a88d-8a7d-4fc6-9758-4205df09bd30",
      "uuid": "6b05433f-8e53-42ad-9b85-23fb5aab82ba",
      "name": "Контейнер средней грузоподъемности для наливных грузов из жесткой пластмассы с конструкционным оснащением",
      "code": "ZJ"
  },
  {
      "guid": "ceb9b05c-6a68-4663-ae9a-72c1f38e1ef8",
      "uuid": "fc606663-8cda-4b12-80be-1be7940c8762",
      "name": "Контейнер средней грузоподъемности для наливных грузов металлический",
      "code": "WM"
  },
  {
      "guid": "dd97947e-4e78-41df-a4ef-1f34346db79e",
      "uuid": "3bd69571-ebe3-4067-abc8-88d4cd798885",
      "name": "Контейнер средней грузоподъемности для наливных грузов составной из гибкой пластмассы",
      "code": "ZR"
  },
  {
      "guid": "f9c0a4b5-0576-4aeb-9822-0a85f59b4c7f",
      "uuid": "345a0dc2-52cd-4d17-bbd7-208e54c3f546",
      "name": "Контейнер средней грузоподъемности для наливных грузов составной из жесткой пластмассы",
      "code": "ZQ"
  },
  {
      "guid": "517d28bb-afa9-4a66-87e7-b707121a70fb",
      "uuid": "6eeb7e9c-9a44-4491-8436-4eb67945b4cb",
      "name": "Контейнер средней грузоподъемности для наливных грузов стальной",
      "code": "WK"
  },
  {
      "guid": "690e086c-89b8-4c17-8838-4478d4c2e4eb",
      "uuid": "5ff12f10-bf65-48a5-9d52-89392cf97f69",
      "name": "Контейнер средней грузоподъемности для твердых навалочных/насыпных грузов из жесткой пластмассы автономный",
      "code": "ZF"
  },
  {
      "guid": "c979e057-03e8-4dda-8fcd-3dba27e4dfc5",
      "uuid": "3f65a1f9-3477-43ba-a674-a315e36a9658",
      "name": "Контейнер средней грузоподъемности для твердых навалочных/насыпных грузов из жесткой пластмассы с конструкционным оснащением",
      "code": "ZD"
  },
  {
      "guid": "9eba63f1-0e89-47a1-b75a-8c0cb099af3d",
      "uuid": "df6aa711-44ed-4c88-bb53-19369eb0836a",
      "name": "Контейнер средней грузоподъемности для твердых навалочных/насыпных грузов составной из гибкой пластмассы",
      "code": "ZM"
  },
  {
      "guid": "3850fb20-746c-4001-827c-5825630f7ce7",
      "uuid": "fd33ba62-fd67-4513-831f-27a187ebfbb4",
      "name": "Контейнер средней грузоподъемности для твердых навалочных/насыпных грузов составной из жесткой пластмассы",
      "code": "ZL"
  },
  {
      "guid": "4258d946-8f37-43ac-90c2-ab29814daaeb",
      "uuid": "211e77f3-b6c8-4dea-b8ee-92b13439f895",
      "name": "Контейнер, галлон",
      "code": "GL"
  },
  {
      "guid": "0239b3d5-ec19-498f-9379-013e4df8c882",
      "uuid": "37b0901a-8898-4b3d-91b6-b1fedea95677",
      "name": "Контейнер, гибкий",
      "code": "1F"
  },
  {
      "guid": "8f20bf8f-afd5-4e30-9e6b-b664f3973c16",
      "uuid": "c8589949-7aea-45f0-945b-c7a406c338e0",
      "name": "Контейнер, прочее транспортировочное оборудование, кроме поименованного",
      "code": "CN"
  },
  {
      "guid": "fedf5cb4-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "bca67915-cbd5-4c28-8334-5e965fdf0753",
      "name": "Корзина",
      "code": "BK"
  },
  {
      "guid": "2bbef079-d872-469a-9a38-37101bba2e07",
      "uuid": "b176058f-eb49-42d3-8aa4-47669161aa61",
      "name": "Корзина из шпона для ягод и фруктов",
      "code": "PJ"
  },
  {
      "guid": "4be2b716-28a4-4d33-8d3e-266ce1e34942",
      "uuid": "2d1c83f0-3067-4056-857d-4babf6663d91",
      "name": "Корзина с крышкой",
      "code": "HR"
  },
  {
      "guid": "497050a3-b994-4ba4-badd-8b7fd98426ac",
      "uuid": "e96d6d80-345c-4f8a-a02d-fe5da4efe1ad",
      "name": "Корзина с ручкой из древесины",
      "code": "HB"
  },
  {
      "guid": "02684a03-6f18-43d0-b79d-3ce05d562435",
      "uuid": "5382a208-5b38-492d-a582-0df8ab23d615",
      "name": "Корзина с ручкой, картонная",
      "code": "HC"
  },
  {
      "guid": "ecd94698-e572-4b54-91a8-54bccd9f5644",
      "uuid": "e8c11520-5d4f-4012-8436-14c4c2e90eaf",
      "name": "Корзина с ручкой, пластмассовая",
      "code": "HA"
  },
  {
      "guid": "e3c233ff-30d4-4ee1-89ac-c19062f1a09d",
      "uuid": "22df4640-913c-4eda-878c-754fe60ca3fa",
      "name": "Корзина, рыбацкая",
      "code": "CE"
  },
  {
      "guid": "2b91c7f0-2705-40a1-a180-64e20626a2a0",
      "uuid": "b9003509-a846-4f80-9c61-1432cd7b1a63",
      "name": "Короб деревянный (лифтван) размером около 220 см (длина) x 115 см (ширина) x 220 см (высота)",
      "code": "LV"
  },
  {
      "guid": "fedf5ad4-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "cc459b06-52e6-4283-be12-585e47f315dd",
      "name": "Коробка",
      "code": "BX"
  },
  {
      "guid": "5a5960a3-121e-4da1-8437-130b3cbc55c6",
      "uuid": "e53f24ea-dd52-4e8b-b282-a8ee93d44679",
      "name": "Коробка (многооборотная) из Общего фонда транспортировочного оборудования ЕС, Еврокоробка",
      "code": "DH"
  },
  {
      "guid": "ff3bfc50-0b9f-47cc-ada2-ac40a4a18cc0",
      "uuid": "9d4f8b72-52c5-4a30-b669-a3d4ce55c012",
      "name": "Коробка деревянная из естественной древесины обыкновенная",
      "code": "QP"
  },
  {
      "guid": "fddc5698-8738-460f-b603-f49c7053b473",
      "uuid": "ac5d20b9-bd53-4910-9628-aeeef54b8a50",
      "name": "Коробка деревянная из естественной древесины с плотно пригнанными стенками",
      "code": "QQ"
  },
  {
      "guid": "77b8f79a-6a69-4b4f-b0b2-a8a9f0f4ca12",
      "uuid": "20bd4991-6c3a-4f5d-a7f2-fcc61bff3a87",
      "name": "Коробка для жидкостей",
      "code": "BW"
  },
  {
      "guid": "9f0f9e11-cce0-4484-9a50-bc4fed7ee1e9",
      "uuid": "c33d8f66-329b-429f-bbf1-885375171bf1",
      "name": "Коробка из древесного материала",
      "code": "4F"
  },
  {
      "guid": "89f4e420-504e-4b2e-9291-ae483d7e9bdd",
      "uuid": "994a8889-5c05-4693-89d1-69606ed78613",
      "name": "Коробка из естественной древесины",
      "code": "4C"
  },
  {
      "guid": "8b1ffe26-1485-477f-8d2d-8050397beab2",
      "uuid": "3a06f23a-83cc-49a3-b6d0-08efeef11d78",
      "name": "Коробка из твердой пластмассы",
      "code": "QS"
  },
  {
      "guid": "aa308c04-0fe0-4a87-ab8c-7527b3f261f4",
      "uuid": "c47d8362-0dfd-4d50-8914-70ef847171dd",
      "name": "Коробка из фибрового картона",
      "code": "4G"
  },
  {
      "guid": "56e38905-209b-43cc-ac8f-3657f5ec2bdc",
      "uuid": "19c925cc-a9cc-46e5-9771-5c8dae149a60",
      "name": "Коробка, алюминиевая",
      "code": "4B"
  },
  {
      "guid": "fedf4328-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "483400f6-eef8-4d94-bebe-9a6bbc5585e8",
      "name": "Коробка, картонная",
      "code": "CT"
  },
  {
      "guid": "50c21cb9-3e09-4cc7-a30f-c724d248e996",
      "uuid": "df871976-5cb4-403f-8fdd-786b9027578e",
      "name": "Коробка, пенопластовая",
      "code": "QR"
  },
  {
      "guid": "dae4571f-d2e8-11e4-8109-d89d67148660",
      "uuid": "e7d21776-e30d-471a-9d84-f8dc9d2cf0e2",
      "name": "Коробка, пластмассовая",
      "code": "4H"
  },
  {
      "guid": "9c0e3d26-e6c5-4b8e-bb47-0a4ecf8867a3",
      "uuid": "854a33cf-19d9-4bbc-8c88-350cad781fd0",
      "name": "Коробка, стальная",
      "code": "4A"
  },
  {
      "guid": "2c76df5b-bdf1-4c36-b136-41240961deb0",
      "uuid": "3193c03c-6297-4ceb-a9aa-9fdc74c953e9",
      "name": "Коробка, фанерная",
      "code": "4D"
  },
  {
      "guid": "890d2d2d-9ed5-40a5-8d6f-bad8546bfee4",
      "uuid": "a024cfe7-d8f9-43a0-9819-6686c679f2de",
      "name": "Кофр",
      "code": "CF"
  },
  {
      "guid": "fedf6240-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "9c777ffa-5cc7-439c-9e86-e92a36f52411",
      "name": "Крюк",
      "code": "HN"
  },
  {
      "guid": "3ae14a0a-3970-45ef-bd53-f278e217bf4f",
      "uuid": "e9f3ecc7-9dae-4e7d-a690-55d4268fdc21",
      "name": "Кувшин, большой",
      "code": "PH"
  },
  {
      "guid": "548062b8-8f49-4fe2-8e93-d6c5103a9113",
      "uuid": "ff8ab3eb-0d8a-4a49-8388-a06f6a38e893",
      "name": "Кувшин, маленький",
      "code": "JG"
  },
  {
      "guid": "5444b894-aa2b-456f-aa27-e1f470568338",
      "uuid": "a489e021-f21e-4745-b0bd-b665d5fdda67",
      "name": "Кулек",
      "code": "AJ"
  },
  {
      "guid": "62120ab7-da8c-46f5-8d06-8cb3f9376a13",
      "uuid": "909d39f7-20f2-4af7-8c5a-2a0261c884ac",
      "name": "Лента",
      "code": "B4"
  },
  {
      "guid": "b9dec3d6-c0d8-4170-8b57-2f79042b9a8d",
      "uuid": "dce2ecf7-8fc6-4cbf-b36d-6bf8a7469a4f",
      "name": "Лист",
      "code": "ST"
  },
  {
      "guid": "b883ff05-483d-4e82-be5f-c1b90d004d1c",
      "uuid": "6e8a3ec5-fd69-47e6-8593-32f8df0a63ea",
      "name": "Лист в пакете/пачке/связке",
      "code": "SZ"
  },
  {
      "guid": "a2e60b9e-ee4d-47b5-956b-690bda852392",
      "uuid": "8184942f-71cd-4df8-8189-c72e7bf0c12f",
      "name": "Лист с пластмассовым покрытием",
      "code": "SP"
  },
  {
      "guid": "d6831ad1-3dc9-48d0-8c92-402db32c4031",
      "uuid": "6ac44f22-a90f-4f06-b8cd-124a4849aa3a",
      "name": "Лист, металлический",
      "code": "SM"
  },
  {
      "guid": "e49e5e21-09f1-4194-b637-655959ce5510",
      "uuid": "03079d9c-6d15-4d99-84cd-8d299037c3b5",
      "name": "Лист, прокладной",
      "code": "SL"
  },
  {
      "guid": "3d72e4ec-f771-4c0d-a9b9-452dd7a08406",
      "uuid": "de9ec880-de49-4d6f-9d62-377f4b3e3b5e",
      "name": "Лоток",
      "code": "PU"
  },
  {
      "guid": "ea504ad8-c159-449f-a752-1ab2eecc8fe1",
      "uuid": "8cd9371b-8feb-4771-8a9a-4900141aa2ec",
      "name": "Лоток",
      "code": "P2"
  },
  {
      "guid": "a5c9db95-0858-401c-a0f8-f1e17f44c156",
      "uuid": "4eb0ddf2-fb23-4de9-bfb2-2ea35fd3ae79",
      "name": "Лоток с двумя настилами без покрытия деревянный",
      "code": "DX"
  },
  {
      "guid": "816aecc8-f89d-4bce-add3-bcea3782ebfa",
      "uuid": "d60f6822-014a-4cdb-a1d3-3071095b7e89",
      "name": "Лоток с двумя настилами без покрытия картонный",
      "code": "DY"
  },
  {
      "guid": "2834ba2d-8030-4b5d-8812-186ff267f89c",
      "uuid": "a6a7a4fd-95d6-4ac9-9041-6eab19564cdb",
      "name": "Лоток с двумя настилами без покрытия пластмассовый",
      "code": "DW"
  },
  {
      "guid": "d5122def-d46e-4989-b845-9ed0754c2a07",
      "uuid": "bee467d2-2c1a-43cd-9541-5d350b029640",
      "name": "Лоток с одним настилом без покрытия деревянный",
      "code": "DT"
  },
  {
      "guid": "b6b93b6c-286a-4c49-b646-bef408d4cf8b",
      "uuid": "2c2aa9c8-7ba8-4293-9183-c8120860074b",
      "name": "Лоток с одним настилом без покрытия картонный",
      "code": "DV"
  },
  {
      "guid": "3614ce14-9970-453c-81df-9645c4c5fe2c",
      "uuid": "169160be-aaaa-40f6-b762-eba8772d693b",
      "name": "Лоток с одним настилом без покрытия пластмассовый",
      "code": "DS"
  },
  {
      "guid": "9c27dc4c-875d-4de5-af1f-d6d066e0d88f",
      "uuid": "1490af9f-ad7e-4514-9ba1-e361750b54ce",
      "name": "Лоток с одним настилом без покрытия полистироловый",
      "code": "DU"
  },
  {
      "guid": "fedf451c-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "8333c895-52bc-46d8-9983-c6ea88a10392",
      "name": "Мешок",
      "code": "BG"
  },
  {
      "guid": "c8bc51d4-de57-44ee-9492-85360eada3a5",
      "uuid": "a571b1a2-acb9-4812-b9d2-a1ed41fe709c",
      "name": "Мешок",
      "code": "TT"
  },
  {
      "guid": "803b1dd4-ea8b-464e-9f7e-1bfa573c90bc",
      "uuid": "dbe8fa28-353c-4edf-a4e7-b41bc990491c",
      "name": "Мешок (куль)",
      "code": "SA"
  },
  {
      "guid": "a71f0123-63c4-440b-bce8-eb46d7a854e2",
      "uuid": "835f1611-a078-4155-b6ec-10fedb916e85",
      "name": "Мешок (куль) многослойный",
      "code": "MS"
  },
  {
      "guid": "fedf401c-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "7f83315d-47b7-4ac6-ad7a-a613c25b3d74",
      "name": "Мешок большой",
      "code": "JB"
  },
  {
      "guid": "933312a8-dc11-43ee-9daa-abb240bf9e3f",
      "uuid": "118124c8-ace0-44e1-b212-ee10dd5c1cdc",
      "name": "Мешок большой для крупноразмерных навалочных грузов",
      "code": "43"
  },
  {
      "guid": "fedf4422-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "e4a94980-15d5-4251-9f01-477a628e954a",
      "name": "Мешок бумажный многослойный",
      "code": "XJ"
  },
  {
      "guid": "9f15aaba-d9e1-43ea-8cc7-0f0a29ed7be8",
      "uuid": "ee46fec9-d11b-441c-9d2d-f7f685c03818",
      "name": "Мешок бумажный многослойный влагонепроницаемый",
      "code": "XK"
  },
  {
      "guid": "87da1e8c-2d92-4de6-8448-6ab233f3847e",
      "uuid": "feb7a5f8-39ca-4e39-a2a6-94c875dd75d6",
      "name": "Мешок из мешковины",
      "code": "GY"
  },
  {
      "guid": "5080bd27-e2b5-4c27-9cb0-7004109f362f",
      "uuid": "45a7865a-c038-4b94-824a-4ee506a5922c",
      "name": "Мешок из полимерной пленки",
      "code": "XD"
  },
  {
      "guid": "fedf4616-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "0b7450bf-b01f-4908-8e0e-967df80303ec",
      "name": "Мешок из полимерной ткани",
      "code": "5H"
  },
  {
      "guid": "c088e3b0-4d1f-4079-8ce3-eca7486da24f",
      "uuid": "b215f296-f02c-4062-ba67-fc707b3c39d9",
      "name": "Мешок из полимерной ткани без внутреннего покрытия/вкладыша",
      "code": "XA"
  },
  {
      "guid": "8d2b467f-d19a-49ad-9d4d-9769fc8adb68",
      "uuid": "37b98649-1d08-465b-af5e-0cef288f8596",
      "name": "Мешок из полимерной ткани влагонепроницаемый",
      "code": "XC"
  },
  {
      "guid": "c311b4f0-1f83-47ff-b5eb-085aa296a443",
      "uuid": "d6abde28-107f-4209-a67e-2bdc2e154a2a",
      "name": "Мешок из полимерной ткани, плотный",
      "code": "XB"
  },
  {
      "guid": "f8296670-1b9b-42fa-9e29-76dc5ba0a8c0",
      "uuid": "5cf1481f-09b1-4b1b-a7c2-229817ebb324",
      "name": "Мешок текстильный",
      "code": "5L"
  },
  {
      "guid": "e50c3c66-a104-46d2-bf1c-b1fb6f649698",
      "uuid": "f16d5d12-83a3-4495-a764-1b42e99b61fd",
      "name": "Мешок текстильный без внутреннего покрытия/вкладыша",
      "code": "XF"
  },
  {
      "guid": "84b62344-fe4f-4585-bdf2-efb3bc68d982",
      "uuid": "bf4523b2-d7a9-444f-ac34-76555808dfd0",
      "name": "Мешок текстильный влагонепроницаемый",
      "code": "XH"
  },
  {
      "guid": "c97033bd-2cf6-4029-a570-0a59b238e68b",
      "uuid": "1e659d6e-3416-4364-88ba-89ac7a0d1a03",
      "name": "Мешок текстильный плотный",
      "code": "XG"
  },
  {
      "guid": "8bb62b02-1b8b-4d1e-8886-93c9484fa5c2",
      "uuid": "78963fbe-1028-4441-a68b-74ff7f7e7ca5",
      "name": "Мешок, большой",
      "code": "ZB"
  },
  {
      "guid": "fedf5e80-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "53e6fc67-14de-4ccc-bf68-a85cbffe385d",
      "name": "Мешок, бумажный",
      "code": "5M"
  },
  {
      "guid": "fdbf9ad8-68d8-49ee-814f-b7d76d806545",
      "uuid": "a446c3fc-b46a-4952-b4ce-11a8f685193f",
      "name": "Мешок, гибкий контейнер",
      "code": "FX"
  },
  {
      "guid": "198ddc36-88da-4659-a5a6-d9acb8416d9d",
      "uuid": "c20292a4-9045-4465-87e4-8a38f4d7e6ad",
      "name": "Мешок, джутовый",
      "code": "JT"
  },
  {
      "guid": "501e2c46-d364-44f5-9f7f-c9697115e4fd",
      "uuid": "f9f004e3-ddcd-40ab-aa3c-8b92ccda99b4",
      "name": "Мешок, пластмассовый",
      "code": "EC"
  },
  {
      "guid": "e806470b-dcf2-447e-8394-b4144b9138df",
      "uuid": "3b0ab8f3-71b6-4c5b-8c55-b65a7f0899aa",
      "name": "Мешок, рогожный",
      "code": "MT"
  },
  {
      "guid": "577431f6-7f08-4f20-af71-7ede3ac2a564",
      "uuid": "7b704255-7f4e-48b7-af82-0185a75028c8",
      "name": "Мягкий мешок, Гибкая цистерна",
      "code": "FE"
  },
  {
      "guid": "d2aeda76-b593-42c6-b6b0-dc1c8338dc54",
      "uuid": "2bac187c-df46-48c8-a7a1-7e0d1610e535",
      "name": "Набор",
      "code": "KI"
  },
  {
      "guid": "3050ca0a-7e39-4cd4-a762-253b981bad21",
      "uuid": "cb37ff07-22e2-4fe2-b12e-d30267903486",
      "name": "Навалом металлолом",
      "code": "VS"
  },
  {
      "guid": "a521f8b3-eeeb-4027-941c-45928d0ecb16",
      "uuid": "600bb7b8-bc57-4a1e-a0b1-76e9c2d44d22",
      "name": "Наливом газ (при 1031 мБар и 15°C)",
      "code": "VG"
  },
  {
      "guid": "791bd3df-24eb-466f-b575-57d9dd1f95b7",
      "uuid": "62d158de-58bc-473c-bf04-0bff6f8d6919",
      "name": "Наливом газ сжиженный (при температуре/давлении, отличающихся от нормальных)",
      "code": "VQ"
  },
  {
      "guid": "22f90a6e-6872-4bd5-a143-063761da6e1a",
      "uuid": "47047e04-9713-46bd-8c3f-d52d1e54671b",
      "name": "Наливом жидкость",
      "code": "VL"
  },
  {
      "guid": "f8ca4252-9ca3-45bd-9a95-8b6a5b538208",
      "uuid": "b4a721e5-7e83-4202-8342-d37e5d44a877",
      "name": "Насыпью твердые гранулированные частицы (гранулы)",
      "code": "VR"
  },
  {
      "guid": "df053993-cf00-43c9-97ea-4c2fa0d07f96",
      "uuid": "b4c8888f-b161-47ba-b15b-04e5a650380f",
      "name": "Насыпью твердые крупные частицы (мелкие куски)",
      "code": "VO"
  },
  {
      "guid": "efb4b760-611d-4f20-80a8-273c315f4db0",
      "uuid": "d67feae4-0a3d-41ba-a719-9c5477efb2b1",
      "name": "Насыпью твердые мелкие частицы (порошки)",
      "code": "VY"
  },
  {
      "guid": "0e254eeb-d882-425d-85cf-ae68b8e50980",
      "uuid": "32dfdafc-ea6b-4793-8b70-a8858e69ab50",
      "name": "Нет сведений",
      "code": "NA"
  },
  {
      "guid": "fedf46fc-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "ef1ef7cb-5431-4fdc-a115-408ad072b2ba",
      "name": "Неупакованный или нерасфасованный",
      "code": "NE"
  },
  {
      "guid": "3fd40265-127d-4fc6-9999-1cdf62f25faf",
      "uuid": "c81af41c-cd40-4c24-9450-3d83106aed19",
      "name": "Неупакованный или нерасфасованный многоместный груз",
      "code": "NG"
  },
  {
      "guid": "2def57e9-6280-4d7d-8765-840aa86e45e1",
      "uuid": "5915ee6d-11ef-4f99-b482-59144bd4af1f",
      "name": "Неупакованный или нерасфасованный одноместный груз",
      "code": "NF"
  },
  {
      "guid": "ed9473f1-647c-4dfc-8ac2-3cba09217165",
      "uuid": "425b861f-eaba-432f-8eb1-c00d35c84a1c",
      "name": "Октабин",
      "code": "OT"
  },
  {
      "guid": "fedf48dc-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "415d0ff4-aa79-4f49-aaf5-4f29d1ea9b6b",
      "name": "Пакет",
      "code": "PA"
  },
  {
      "guid": "cd449f46-29f4-42af-8d36-046f0954ae63",
      "uuid": "a3d6d513-2f80-430c-8258-3cc63b987aab",
      "name": "Пакет (мешочек)",
      "code": "PO"
  },
  {
      "guid": "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
      "uuid": "a7363144-e6a0-4af0-832f-0d403fdeb761",
      "name": "Пакет (пачка/связка)",
      "code": "BE"
  },
  {
      "guid": "6fddb358-43dd-4030-a1a7-a1a3c8c489ad",
      "uuid": "816f802e-dc90-40ab-ac45-12e92d78d370",
      "name": "Пакет бумажный многослойный",
      "code": "MB"
  },
  {
      "guid": "cf45058e-1f10-42fa-ae97-b2afefac9489",
      "uuid": "e883758e-dae5-4b12-84f4-2c19b3fc939e",
      "name": "Пакетик",
      "code": "SH"
  },
  {
      "guid": "63c5ba04-a314-4d41-9a0f-d328fba0144a",
      "uuid": "8f22b03a-f3ee-481c-9821-d5f005b66bcd",
      "name": "Пачка (пакет/связка)",
      "code": "BH"
  },
  {
      "guid": "aeba3537-a7ed-4c11-8cfc-a05de5280f73",
      "uuid": "342f6a4b-186c-439b-b551-353d338ecefa",
      "name": "Пачка деревянная",
      "code": "8C"
  },
  {
      "guid": "240ef107-fad5-4fca-bad1-ae65ab388ac6",
      "uuid": "f0f58320-65d9-49e3-8f90-5cacf8ef554d",
      "name": "Плита",
      "code": "PG"
  },
  {
      "guid": "4b2de153-2c3e-499e-91f8-a7ce1926157a",
      "uuid": "b7e8a823-312d-4050-8f6b-68772f9cc4b0",
      "name": "Плиты в пакете/пачке/связке",
      "code": "PY"
  },
  {
      "guid": "a8e05c09-1c89-46a8-8362-b2388f820fdb",
      "uuid": "4d0d987a-9796-42f5-89b9-47b787e18a60",
      "name": "По взаимному определению",
      "code": "ZZ"
  },
  {
      "guid": "fedf615a-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "65d867fa-a9b9-40ae-94ca-df4ec95134ef",
      "name": "Поддон",
      "code": "PX"
  },
  {
      "guid": "fedf56f6-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "60f00efb-fca8-4398-9ea2-17fc1249d7e0",
      "name": "Поддон",
      "code": "TW"
  },
  {
      "guid": "83ee9a1e-5c1c-438b-bb63-48ed654e63ef",
      "uuid": "d1050bd2-18f5-48b9-9293-bd96b4a8a97b",
      "name": "Поддон 100 x 110 см",
      "code": "AH"
  },
  {
      "guid": "280069cf-3cff-4cb3-a96d-5632944e3f9c",
      "uuid": "9610cbe3-64c9-447a-ba49-03e3f2aacc66",
      "name": "Поддон в термоусадочной пленке",
      "code": "AG"
  },
  {
      "guid": "d520e4b3-dd9b-4f34-9148-ccac220b9c84",
      "uuid": "2c0b2022-45bd-4218-9a67-617278d36cbe",
      "name": "Поддон деревянный",
      "code": "8A"
  },
  {
      "guid": "82286818-b97d-42ef-b5e2-d1a1ac1c18cf",
      "uuid": "9d624dfc-5f61-42fe-af58-5d7a70f5f3e7",
      "name": "Поддон модульный с обечайкой 80 x 100 см",
      "code": "PD"
  },
  {
      "guid": "d1d65e12-85c6-4492-8407-de44d792ac1f",
      "uuid": "54502d23-7eb7-4791-9b37-64c332059744",
      "name": "Поддон модульный с обечайкой 80 x 60 см",
      "code": "AF"
  },
  {
      "guid": "d79600b3-7498-4a9b-a873-d58fce2a667d",
      "uuid": "4bee32c3-c4d0-4ed2-9d06-2acf3d2de0c3",
      "name": "Поддон модульный с обечайкой 80 х 120 см",
      "code": "PE"
  },
  {
      "guid": "d9d55e79-0ba6-4c11-9761-0e10dc1c6c8e",
      "uuid": "545e1086-b1cc-4161-94eb-236a3b233b9d",
      "name": "Поддон, ящичный",
      "code": "PB"
  },
  {
      "guid": "81b74091-f9db-436f-b6a9-2438f3fbba32",
      "uuid": "9f66c8b8-01bc-43b2-8535-19be1fd17aae",
      "name": "Прут",
      "code": "RD"
  },
  {
      "guid": "cfc437d8-9bfe-4d56-8d0e-4f35e5ae3af6",
      "uuid": "fb87f15e-6562-4d26-8a99-0a113c12d656",
      "name": "Прут в пакете/пачке/связке",
      "code": "RZ"
  },
  {
      "guid": "c91b91dc-6dff-49f6-90eb-19824f81b675",
      "uuid": "aeac6265-cf9e-458a-9a62-e506bb7814af",
      "name": "Пульверизатор",
      "code": "AT"
  },
  {
      "guid": "770d2025-1d5e-463a-82bc-ce7bceb3cc90",
      "uuid": "ea5f2444-4d08-4713-8eba-ceaaa1f7b014",
      "name": "Рама",
      "code": "FR"
  },
  {
      "guid": "2d523fde-44a2-4c21-891b-4bccdcb1a33e",
      "uuid": "90c0b093-c941-401f-a6a1-30057af63d14",
      "name": "Рулон (обивочного или настилочного материала)",
      "code": "BT"
  },
  {
      "guid": "f65e0788-1ba1-46f5-b677-d7590cc6c745",
      "uuid": "d050ab13-df54-4698-981d-d9fb1592d1be",
      "name": "Рулон (полосового материала)",
      "code": "RO"
  },
  {
      "guid": "07aa7b0e-2a80-45ba-b3bd-6060eef8376b",
      "uuid": "e2a1188e-4202-4c65-af89-ba870956b34c",
      "name": "Связка",
      "code": "TS"
  },
  {
      "guid": "ed7372ee-8b55-4e69-aa90-956a68b836ae",
      "uuid": "5935f443-d63f-442a-80e3-1ef5bde58d32",
      "name": "Сетка",
      "code": "NT"
  },
  {
      "guid": "5f3d0b50-196e-498d-8994-7dfd1d9661cc",
      "uuid": "168dca82-1219-43bf-8d61-8c38fd73f1a0",
      "name": "Сетка типа используемой для овощей или фруктов",
      "code": "RT"
  },
  {
      "guid": "fe9cc400-101e-4dee-a90f-705c71bb560e",
      "uuid": "a9c7e4fc-ead1-4b9c-b29b-2eeae1de33f4",
      "name": "Сетка трубчатая пластмассовая",
      "code": "NU"
  },
  {
      "guid": "1943c156-b96c-4b64-8935-dfd11e95d495",
      "uuid": "48e06d36-ea2c-4da3-92cc-9ea16de7ba0a",
      "name": "Сетка трубчатая текстильная",
      "code": "NV"
  },
  {
      "guid": "29f1456b-e328-4f1b-b855-41eda829a9e1",
      "uuid": "dba6e871-d890-48d0-bbed-3a37d16049e9",
      "name": "Слитки в пакете/пачке/связке",
      "code": "IZ"
  },
  {
      "guid": "c954a839-e145-40f0-8945-de8e4faad748",
      "uuid": "22b956db-fd0c-4aff-9977-4a503828eb4e",
      "name": "Слиток",
      "code": "IN"
  },
  {
      "guid": "000000f8-8e27-4cb0-9e34-6d99fd90d7df",
      "uuid": "cc98ec51-8934-4aa8-8aab-60e7a4d30d6e",
      "name": "Сляб",
      "code": "SB"
  },
  {
      "guid": "322566af-9e46-4f63-bf22-041d4d2d9c58",
      "uuid": "ff9bbcaf-131f-4e2d-bbeb-d8b3b054e1b5",
      "name": "Сосуд с пластмассовым покрытием",
      "code": "MW"
  },
  {
      "guid": "bc592630-266f-425c-be8b-911425c04ccf",
      "uuid": "89c8f356-f0a2-4075-99a0-d73edc1b45a4",
      "name": "Сосуд, бумажный",
      "code": "AC"
  },
  {
      "guid": "a7a51764-3c6d-4dec-997d-c5b08d8e2d74",
      "uuid": "e29910b0-8439-4705-85d0-a5c1d71ec652",
      "name": "Сосуд, деревянный",
      "code": "AD"
  },
  {
      "guid": "0509b85d-01ca-4a62-bc40-283eff6ead2d",
      "uuid": "9529a3a1-e022-48b7-bfa5-1127056d9e40",
      "name": "Сосуд, металлический",
      "code": "MR"
  },
  {
      "guid": "876203e4-1352-455a-8c97-92c3460acc3a",
      "uuid": "574f7075-f439-4b4b-ae46-960de49073cd",
      "name": "Сосуд, пластмассовый",
      "code": "PR"
  },
  {
      "guid": "251a4096-c3d6-4b0c-8534-65b31d41f633",
      "uuid": "1a3e2fd8-997c-4f44-80e1-c9e3d3c58960",
      "name": "Сосуд, стеклянный",
      "code": "GR"
  },
  {
      "guid": "ef542239-f46a-4552-a332-db330f73b646",
      "uuid": "752a47c5-5c6d-46e3-b2c9-255ebca7d924",
      "name": "Сосуд, фибровый",
      "code": "AB"
  },
  {
      "guid": "6bcddbae-2d7b-455c-83b3-6a65731d4e9f",
      "uuid": "fd6f5161-9b28-4f62-8b44-c052cc0bce66",
      "name": "Спичечный коробок",
      "code": "MX"
  },
  {
      "guid": "2f2ba5e2-c9ab-41af-83d8-592f65c01db4",
      "uuid": "b6ea4d40-1efb-4f48-8231-a13291e7b802",
      "name": "Стеллаж",
      "code": "SI"
  },
  {
      "guid": "2d3b2408-d028-42e1-bc72-941b7fa149b5",
      "uuid": "93def760-906b-48aa-8f48-d8777ccb11f9",
      "name": "Стойка",
      "code": "RK"
  },
  {
      "guid": "28f26068-5294-4c8a-b409-c0a7ae10efd9",
      "uuid": "62e793a4-2647-4d8c-b99a-14b4b9fca6e0",
      "name": "Стойка, вешалка для одежды",
      "code": "RJ"
  },
  {
      "guid": "ed6ec9a4-fb93-420a-9e1d-884aa58849c4",
      "uuid": "a49e179e-cc77-4798-a608-dc21e834178b",
      "name": "Сундук",
      "code": "CH"
  },
  {
      "guid": "bf12e4f9-56be-4b62-a0d6-22f01585db25",
      "uuid": "624acfa0-7f8f-469f-8e32-9b3f4f1655b9",
      "name": "Сундук, дорожный",
      "code": "TR"
  },
  {
      "guid": "022887ce-8f39-4b81-b26e-785f114c7ac7",
      "uuid": "b49cf3a7-caa6-4fb8-a010-75cef6a74479",
      "name": "Сундук, морской",
      "code": "SE"
  },
  {
      "guid": "dbff7b51-2571-451e-bf15-66e2ceed2fcb",
      "uuid": "9199ff45-abab-4693-bf04-f5e3420ee15d",
      "name": "Сундучок",
      "code": "FO"
  },
  {
      "guid": "730968d5-30e1-4cc8-b413-d5997e8898a5",
      "uuid": "7c55f754-0bfe-404c-993e-8a8cd6c9be94",
      "name": "Таблетка",
      "code": "T1"
  },
  {
      "guid": "7c585ad5-34f3-4975-a0aa-a78229e71808",
      "uuid": "ba5bfa03-f97e-45ab-b09b-ffdb5e4f83b6",
      "name": "Труба",
      "code": "PI"
  },
  {
      "guid": "f5144819-a94a-486d-91d7-eb38a074c6c1",
      "uuid": "edc7e494-26f6-4b5a-bc32-27779a7e5b80",
      "name": "Труба в пакете/пачке/связке",
      "code": "PV"
  },
  {
      "guid": "06eb9e3a-d6a8-49c3-809a-b4150b90e210",
      "uuid": "65e16bdb-3062-4225-af13-81543dc6b18a",
      "name": "Трубка или туба",
      "code": "TU"
  },
  {
      "guid": "54d1cc31-f51c-4e2a-9230-009c57aaa517",
      "uuid": "abc2ff02-2b9d-4f62-8de5-1bb63af4d62e",
      "name": "Трубка или туба в пакете/пачке/связке",
      "code": "TZ"
  },
  {
      "guid": "0c009153-57e0-4dfa-8e5f-ece82ae4dfef",
      "uuid": "8b0d41b8-c7e8-43b2-b170-3f04b3a19187",
      "name": "Трубка или туба с насадкой",
      "code": "TV"
  },
  {
      "guid": "6858e1ff-229f-43e0-9b3b-dd6ac0b41485",
      "uuid": "723901d0-3eff-4168-917c-5aa9df1b8994",
      "name": "Трубка или туба, складывающаяся",
      "code": "TD"
  },
  {
      "guid": "eb23a947-4fd9-46e6-8a6f-f258433500e7",
      "uuid": "3b530c95-3bb0-4675-b081-cd56394558f1",
      "name": "Упаковка",
      "code": "PK"
  },
  {
      "guid": "7ca4b4f3-fcac-4c00-8d7a-b258acaa97f0",
      "uuid": "0faef5db-a34e-450c-90b5-91ca369af18b",
      "name": "Упаковка в оберточной бумаге",
      "code": "IG"
  },
  {
      "guid": "b5dd6d4d-b99e-4245-8a92-abc119e1889f",
      "uuid": "53b0f397-182a-4df6-a005-c71974ee0c35",
      "name": "Упаковка демонстрационная деревянная",
      "code": "IA"
  },
  {
      "guid": "67129e5f-36d2-4397-8122-0c18747d2344",
      "uuid": "7a885b94-1aa5-4434-8547-1f999ff65ce1",
      "name": "Упаковка демонстрационная картонная",
      "code": "IB"
  },
  {
      "guid": "add23067-88c7-4cc0-a251-8c67953d00ce",
      "uuid": "4dc7bc1e-91a5-4998-8724-2d3a7f77755a",
      "name": "Упаковка демонстрационная металлическая",
      "code": "ID"
  },
  {
      "guid": "dfe5cf21-dbc5-4f51-b7fd-ad45259f9677",
      "uuid": "362dec1c-1e08-4953-bc95-5921b1e007cd",
      "name": "Упаковка демонстрационная пластмассовая",
      "code": "IC"
  },
  {
      "guid": "c2645eda-085d-4ae7-bfc2-641fc380ebae",
      "uuid": "3f12daba-8209-4ee9-95cb-7e84abc85533",
      "name": "Упаковка картонная с отверстиями для бутылок",
      "code": "IK"
  },
  {
      "guid": "9b0b180a-7cbb-4d9a-ba41-fd08b0eae3ba",
      "uuid": "f0ee662c-dd76-4914-9cda-10d3cdf70b7d",
      "name": "Упаковка, выпрессованная",
      "code": "IF"
  },
  {
      "guid": "ec874c34-8d51-4e04-bd2c-9ec9642d1e0e",
      "uuid": "6c74b50c-8eae-4ae2-9a2d-9887044673c1",
      "name": "Упаковка, выставочная",
      "code": "IE"
  },
  {
      "guid": "a283d481-0a41-4d0a-9c38-e386caac0d70",
      "uuid": "b0e2f762-3188-4be6-9a99-69c3d6a49357",
      "name": "Флакон",
      "code": "VI"
  },
  {
      "guid": "2ca9172d-edad-4d6f-a4b8-e4fbaae098cb",
      "uuid": "57e7a24c-329b-49cd-9967-499adf48c5c1",
      "name": "Фляга",
      "code": "FL"
  },
  {
      "guid": "07c59e7c-4a8c-4035-8048-2847491c88ea",
      "uuid": "8e140d3a-f304-4d4c-b92f-1e9feb70f15e",
      "name": "Цилиндр",
      "code": "CY"
  },
  {
      "guid": "fedf5d9a-053c-11e1-99b4-d8d385fbc9e8",
      "uuid": "2b06b0b3-1f1c-48ef-8bcf-8fbed8e0caad",
      "name": "Цистерна контейнер универсальный",
      "code": "TG"
  },
  {
      "guid": "a5e4fb2f-f40b-40ab-bd2d-f6ddabbd4460",
      "uuid": "0aadb4d7-aad6-4de9-9b45-24bc9a5978d5",
      "name": "Цистерна, прямоугольная",
      "code": "TK"
  },
  {
      "guid": "6fd54b8c-d35a-4655-b2f2-2491429b0931",
      "uuid": "35bf0419-8235-465c-b037-826635f7c89f",
      "name": "Цистерна, цилиндрическая",
      "code": "TY"
  },
  {
      "guid": "59eac884-a3ee-4c87-86ef-2508d1328ee6",
      "uuid": "8f150a20-b162-4ce7-80a8-8726a4494bc8",
      "name": "Чайная коробка",
      "code": "TC"
  },
  {
      "guid": "6eb46a7f-f1c0-49fd-b38c-47c8177aa9e1",
      "uuid": "e88d316c-b516-4d6b-a5b8-ea8981a087cb",
      "name": "Чан",
      "code": "BM"
  },
  {
      "guid": "bfbecab2-acff-4791-8f4f-b03d435d00c8",
      "uuid": "94258f44-6bad-4376-a5b5-c025d99c4885",
      "name": "Чаша",
      "code": "CU"
  },
  {
      "guid": "8f4c7cbd-7d4a-48d6-873f-9f4a37bd576c",
      "uuid": "5544f6b8-4ade-44d2-a3e1-341fcace286b",
      "name": "Чемодан",
      "code": "SU"
  },
  {
      "guid": "354aee98-06a3-4780-bc9a-00a57edd8ca7",
      "uuid": "199655ba-3bf7-4183-817b-a592fda4a2c1",
      "name": "Чехол",
      "code": "CV"
  },
  {
      "guid": "62f322c4-ce6d-4584-ba3f-4c771406f54d",
      "uuid": "2f67ae02-b72a-4c49-93f9-73c5aa26c0c9",
      "name": "Шар",
      "code": "AL"
  },
  {
      "guid": "0bf57833-4b9d-4d99-96a3-53c7263e01e6",
      "uuid": "09e0f972-1692-407c-82c0-4abc524321e5",
      "name": "Шина",
      "code": "TE"
  },
  {
      "guid": "dd7b8b5b-fcf3-46bf-9955-e2c5f9cc25f6",
      "uuid": "fe97049b-0b4a-488b-8978-81419af3bbb3",
      "name": "Шпиндель",
      "code": "SD"
  },
  {
      "guid": "969bfad0-be8f-43fe-84d8-32ebfe32d37d",
      "uuid": "26e921e9-114b-48cc-97e8-ca732a30ba00",
      "name": "Шпулька",
      "code": "SO"
  },
  {
      "guid": "25b9eab3-0f9f-42c1-912b-10f78bc63901",
      "uuid": "84a3bdc1-19a5-4778-9fee-52f2563fc255",
      "name": "Штабель",
      "code": "PF"
  },
  {
      "guid": "6090531d-d038-4f6c-a8df-77ba92267ec4",
      "uuid": "71f854f1-5d73-47ae-bb16-d0779dbf2d81",
      "name": "Штука",
      "code": "PP"
  },
  {
      "guid": "bd8a4719-4595-4e82-a2e6-9ea20afcbf6e",
      "uuid": "4e002e2a-cb14-4b06-88f6-c017266a7ed3",
      "name": "Ящик",
      "code": "CS"
  },
  {
      "guid": "7c29a864-e469-4c64-89e7-153000939d61",
      "uuid": "7726f1f8-49fc-4707-8ccd-ec8a4bc0402c",
      "name": "Ящик",
      "code": "LU"
  },
  {
      "guid": "563fadd5-faa2-4d28-9139-1f23e08ae0af",
      "uuid": "e7bef380-e105-4ba0-9798-4d8d2a19d910",
      "name": "Ящик автомобильный",
      "code": "7A"
  },
  {
      "guid": "61079f21-ef62-44bc-97a7-817029f4d251",
      "uuid": "09e0730d-ab9a-4278-a737-7062e10627da",
      "name": "Ящик деревянный",
      "code": "7B"
  },
  {
      "guid": "3d01bd9f-6629-4ec1-9ebe-532d82379a14",
      "uuid": "1aa4dc95-1b4a-4845-b4ea-61458039520c",
      "name": "Ящик деревянный",
      "code": "8B"
  },
  {
      "guid": "d8f7a02c-5076-41a2-9258-cca3427993b4",
      "uuid": "abd09b06-43b8-4c53-9ee5-c7948de099fd",
      "name": "Ящик металлический",
      "code": "MA"
  },
  {
      "guid": "668f1a9f-3b4c-496a-8c01-c6d1bd87d917",
      "uuid": "637c1f51-ee03-4060-8032-ed4425e05016",
      "name": "Ящик решетчатый (или обрешетка) мелкий",
      "code": "SC"
  },
  {
      "guid": "aabbf190-ba1f-4611-8a97-6ce660a1dbc3",
      "uuid": "02da2f47-a032-4971-beea-5364df8acb9c",
      "name": "Ящик решетчатый (или обрешетка) многослойный деревянный",
      "code": "DB"
  },
  {
      "guid": "f1a52766-b434-4e89-8440-60ba8df518c3",
      "uuid": "76b574e3-f95a-4adb-9be5-dd36661bb011",
      "name": "Ящик решетчатый (или обрешетка) многослойный картонный",
      "code": "DC"
  },
  {
      "guid": "5fc55705-10dd-4071-a5ec-bd2337e98b95",
      "uuid": "21c0d24c-b301-4dd2-9bdf-1cb5a10b1d34",
      "name": "Ящик решетчатый (или обрешетка) многослойный пластмассовый",
      "code": "DA"
  },
  {
      "guid": "c1444369-7a47-4e53-8e62-c33c290d73c2",
      "uuid": "4adbf919-b481-40a3-a6c4-745be2854950",
      "name": "Ящик решетчатый (или обрешетка) рамный",
      "code": "FD"
  },
  {
      "guid": "fe47d256-3d2b-4460-87e3-349ee65f6ac0",
      "uuid": "dcdae168-7b0f-4ba0-9495-953e2ceb86c7",
      "name": "Ящик решетчатый для бутылок",
      "code": "BC"
  },
  {
      "guid": "e879ae24-cac7-4dd1-a0e5-1d433b3493ab",
      "uuid": "94b723d2-8a96-4c00-8d2c-5ca9cde6efc5",
      "name": "Ящик решетчатый для массовых грузов деревянный",
      "code": "DM"
  },
  {
      "guid": "ebf8776f-0e3d-4aff-bc64-28fb6e93a6fb",
      "uuid": "b7f57644-e943-4b7e-a929-a130ca338d6d",
      "name": "Ящик решетчатый для массовых грузов картонный",
      "code": "DK"
  },
  {
      "guid": "7c4ea86f-477d-499e-b9b5-281c8d7cb2a5",
      "uuid": "8100ec3b-74c5-47e7-8ce9-0d7d60a076d9",
      "name": "Ящик решетчатый для массовых грузов пластмассовый",
      "code": "DL"
  },
  {
      "guid": "dcf6eeb2-a0fd-4f1c-83db-7a85354a7c84",
      "uuid": "5912745b-400e-4a42-afe4-801d020145bf",
      "name": "Ящик решетчатый для молока",
      "code": "MC"
  },
  {
      "guid": "9e2b9bfb-8f54-4a66-ad38-d650ca479e44",
      "uuid": "4e948220-a235-41ab-a060-1783b3344ddc",
      "name": "Ящик решетчатый для пива",
      "code": "CB"
  },
  {
      "guid": "3ea227b5-df09-40c2-b802-8abd1427c73e",
      "uuid": "d3991117-ab9f-48f6-abce-09d762757405",
      "name": "Ящик решетчатый для фруктов",
      "code": "FC"
  },
  {
      "guid": "93266aa3-4642-4162-8155-01851a5c0811",
      "uuid": "6dc741c9-44a5-46f3-ba76-66cbac17e5fb",
      "name": "Ящик с поддоном",
      "code": "ED"
  },
  {
      "guid": "a106dd9b-f9ee-45d6-a4f7-d8c18a1c53ea",
      "uuid": "42513601-0221-403b-9aef-e23c8a66581a",
      "name": "Ящик с поддоном деревянный",
      "code": "EE"
  },
  {
      "guid": "dbb7a1d0-aa1f-4141-90e2-1db559dd20f7",
      "uuid": "395a6d37-d2ca-4ae2-b4af-b76ed722550b",
      "name": "Ящик с поддоном картонный",
      "code": "EF"
  },
  {
      "guid": "4ad07608-39ee-4991-baac-9cd2bdb5b2b0",
      "uuid": "4565f1c2-3240-4508-b1da-995a7e42e0c0",
      "name": "Ящик с поддоном металлический",
      "code": "EH"
  },
  {
      "guid": "215592ec-b08d-401b-800d-d36bda9ba0b5",
      "uuid": "7d36302b-8c40-4eb2-ac18-4bb257a7d6aa",
      "name": "Ящик с поддоном пластмассовый",
      "code": "EG"
  },
  {
      "guid": "a451a297-b510-48fc-8a31-a41e311a0d82",
      "uuid": "93075c71-f992-4819-bc30-a5b2b3974ab5",
      "name": "Ящик, изотермический",
      "code": "EI"
  },
  {
      "guid": "5bca0d26-c06d-4fbd-a75a-39b098f7a5d8",
      "uuid": "15f75128-2610-4f36-bea4-1a3a35927602",
      "name": "Ящик, каркасный",
      "code": "SK"
  },
  {
      "guid": "e2437340-c529-4655-9774-c61054d429a5",
      "uuid": "9bbc2877-2c64-47d3-9cd9-2aabd6b5fdfe",
      "name": "Ящик, решетчатый (или обрешетка)",
      "code": "CR"
  },
  {
      "guid": "a4992438-8d0c-45b2-9ffd-669dff708417",
      "uuid": "c87e5652-0fc3-4fcc-99f3-8dd4c1c8186a",
      "name": "Ящик, стальной",
      "code": "SS"
  }
]

// export const DEFAULT_ENTERPRISE = {
//     "name": "ПАО \"БАШИНФОРМСВЯЗЬ\"",
//     "type": "1",
//     "numberList": [
//         "RU002:85226315"
//     ],
//     "address": {
//         "country": {
//             "name": "Российская Федерация",
//             "guid": "74a3cbb1-56fa-94f3-ab3f-e8db4940d96b",
//             "uuid": "72a84b51-5c5e-11e1-b9b7-001966f192f1"
//         },
//         "region": {
//             "name": "Башкортостан",
//             "guid": "6f2cbfd8-692a-4ee4-9b16-067210bde3fc",
//             "uuid": "7bcf117f-40c9-40e5-86ed-a05ba872495c"
//         },
//         "locality": {
//             "name": "Уфа",
//             "guid": "7339e834-2cb4-4734-a4c7-1fca2c66e562",
//             "uuid": "833d38cf-97e8-4388-9eb6-472de9def3f7"
//         },
//         "street": {
//             "name": "Ленина",
//             "guid": "acf9b6b8-9847-4cdc-8733-f7be5c1ab745",
//             "uuid": "f01ea10e-1c3a-4332-95f7-db6c4e9b21fc"
//         },
//         "house": "30",
//         "postBox": "450077",
//         "addressView": "450077, Республика Башкортостан, г. Уфа, ул. Ленина, д. 30"
//     },
//     "owner": {
//         "juridicalAddress": {
//             "addressView": "450077, Российская Федерация, Республика Башкортостан, г. Уфа, Ленина ул., д. Д. 30"
//         },
//         "guid": "75a23f8f-05d5-493a-893a-d97cb4de86be",
//         "uuid": "41d7ec34-b522-4835-82f9-2a93cb4b21b4"
//     },
//     "registryStatus": 0,
//     "guid": "0a69974d-85ac-4480-95f6-1e5e07267b70",
//     "active": false,
//     "last": false,
//     "status": "100",
//     "createDate": "2025-11-24T16:57:09+00:00",
//     "updateDate": "2025-12-18T12:50:36+00:00",
//     "next": "66e2eada-517b-4709-a62b-52a6baebf375",
//     "uuid": "158448db-5c65-4b86-b181-8093221a44ae"
// }
export const DEFAULT_ENTERPRISE = {
    "name": "РОСТЕЛЕКОМ",
    "type": "1",
    "numberList": [
        "RU033:16678063"
    ],
    "address": {
        "country": {
            "name": "Российская Федерация",
            "guid": "74a3cbb1-56fa-94f3-ab3f-e8db4940d96b",
            "uuid": "72a84b51-5c5e-11e1-b9b7-001966f192f1"
        },
        "region": {
            "name": "Владимирская",
            "guid": "b8837188-39ee-4ff9-bc91-fcc9ed451bb3",
            "uuid": "18489346-08c0-41f4-9a46-b9d1f5a819d9"
        },
        "locality": {
            "name": "Муром",
            "guid": "0d7d5d87-f0a6-428f-b655-d3be106c64a2",
            "uuid": "05c2b5fb-cdb6-41f6-a4a6-0209b435aad3"
        },
        "addressView": "600021, обл.Владимирская, г.Муром, ул.Октябрьской Революции,д.2Б"
    },
    "owner": {
        "juridicalAddress": {
            "addressView": "450077, Российская Федерация, Республика Башкортостан, г. Уфа, Ленина ул., д. Д. 30"
        },
        "guid": "75a23f8f-05d5-493a-893a-d97cb4de86be",
        "uuid": "41d7ec34-b522-4835-82f9-2a93cb4b21b4"
    },
    "officialRegistration": [
        {
            "businessEntity": {
                "inn": "7707049388",
                "guid": "b5a3aedd-c781-4860-9688-cce8e1c4d3ca",
                "uuid": "99c60fc7-288b-4f33-8525-19b003735b36"
            },
            "kpp": "784201001"
        }
    ],
    "registryStatus": 0,
    "guid": "9b3fef2a-ea11-4557-90c2-3a0cede16072",
    "active": true,
    "last": true,
    "status": "100",
    "createDate": "2025-12-19T10:39:49+00:00",
    "updateDate": "2025-12-19T10:39:49+00:00",
    "uuid": "6032d6e6-662e-41f7-9a14-5e92fb2f06eb"
}

export const DEFAULT_STOCK_RESULT = {
  encoding: 0,
  content: {
    stockEntryList: {
      stockEntry: [
        {
          entryNumber: "18368549",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 400,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "02bd1cbb-5c74-6fe9-e46f-bc85b228976f",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "971a91c7-327b-425a-b2ee-f7d7269e0cb7"
            }
          ],
          guid: "423c7c8e-00a7-424a-9d6d-716e1331a443",
          active: true,
          last: true,
          status: "103",
          createDate: "2017-08-07T13:22:35+03:00",
          updateDate: "2017-08-07T13:22:35+03:00",
          uuid: "07275356-703a-45de-a03c-4d3573d94567"
        },
        {
          entryNumber: "18368548",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 400,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "08e42357-7277-4c0a-8cf9-cf5795db8d85",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "09779755-d079-49d0-8451-cab69f5b51be"
            }
          ],
          guid: "bf0d98aa-1e46-46c7-a205-89336a87ed9c",
          active: true,
          last: true,
          status: "103",
          createDate: "2017-08-07T13:22:35+03:00",
          updateDate: "2017-08-07T13:22:35+03:00",
          uuid: "60368bd5-1999-45b5-9811-dd50ca289428"
        },
        {
          entryNumber: "18368550",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 400,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "26845944-cb3e-06ff-1554-bee08c03db4e",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "89f500ca-3716-441d-8ab0-62b3a25b17bc"
            }
          ],
          guid: "c85ab5c7-fb59-45d2-8e25-37fc261b269b",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:43+03:00",
          updateDate: "2017-08-07T13:22:43+03:00",
          previous: "5e60d2c6-27fa-464b-8a69-beb477fc437a",
          uuid: "3d816033-6648-4f46-ba6a-72899a6edb79"
        },
        {
          entryNumber: "18368551",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 100,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "0a69974d-85ac-4480-95f6-1e5e07267b70",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "9a7c9803-d628-4eb8-9742-df1ed4045e18"
            }
          ],
          guid: "df257f58-60f3-46d8-8c27-f98e58448e2f",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:42+03:00",
          updateDate: "2017-08-07T13:22:42+03:00",
          previous: "3b0dd37e-7587-4054-9ceb-611996d6f225",
          uuid: "0def7ed9-8496-480a-ad65-acf573203508"
        },
        {
          entryNumber: "18368552",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 398,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "02bd1cbb-5c74-6fe9-e46f-bc85b228976f",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "32999315-c733-465e-9c1e-b096d65f22b7"
            }
          ],
          guid: "cf934ac2-cb29-40c0-bd4f-8061e228d682",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:44+03:00",
          updateDate: "2017-08-07T13:22:44+03:00",
          previous: "bc3ce96b-b7bf-462a-8045-a659e612c575",
          uuid: "f91d43c7-efac-4f6a-97c3-b9f60219c547"
        },
        {
          entryNumber: "18368554",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 398,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "08e42357-7277-4c0a-8cf9-cf5795db8d85",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "d8bf8c9b-9ea4-4130-8032-5615b26ffe2b"
            }
          ],
          guid: "28f8e295-21df-4342-aa04-a17f76d39f6a",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:45+03:00",
          updateDate: "2017-08-07T13:22:45+03:00",
          previous: "7b18c7a4-7260-4603-9ce2-351723dacb33",
          uuid: "08472a30-3cd0-481f-80e5-512b9f244eec"
        },
        {
          entryNumber: "18368557",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 398,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "b38a4b16-5678-4c69-967c-3bceb344abc9",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "c042f529-919c-4251-ba16-84f452be21b3"
            }
          ],
          guid: "447b6785-b92d-4c14-9ac1-08a581b25b17",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:45+03:00",
          updateDate: "2017-08-07T13:22:45+03:00",
          previous: "af61ce07-57b7-4e53-8d83-b7fd2af05f49",
          uuid: "6cb948e0-1626-499d-9d2a-772b0b931a8c"
        },
        {
          entryNumber: "18368558",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 100,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "b817ff40-2638-491b-8288-600129f48efa",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "ae820582-c821-4068-a4c2-db171e6db0ef"
            }
          ],
          guid: "33281503-1c1c-4067-9451-94badcc27264",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:45+03:00",
          updateDate: "2017-08-07T13:22:45+03:00",
          previous: "dbd34a9e-250f-4d79-96a9-0b6c08d71840",
          uuid: "100f4d6d-1153-42fc-aa05-d0bdcf9c1184"
        },
        {
          entryNumber: "18368561",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 399,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 6
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 6
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "bd457e9b-a8a1-49d2-9088-24bc50a351dd",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "1a62ba42-b375-4847-a9ef-40d43f9eefa4"
            }
          ],
          guid: "35f2663b-cc47-4815-87a3-3bde6d029eb7",
          active: true,
          last: true,
          status: "202",
          createDate: "2017-08-07T13:22:47+03:00",
          updateDate: "2017-08-07T13:22:47+03:00",
          previous: "a39ef540-db26-4a78-b62b-e43c92eec539",
          uuid: "fb1e1735-daa8-427d-a1f9-697e2d9409ba"
        },
        {
          entryNumber: "18368564",
          batch: {
            productType: 5,
            product: {
              guid: "d34504bb-7a93-e1c8-4859-339eafd97c6c",
              uuid: "31c94ff1-a217-f38d-6005-1aa5ca67e146"
            },
            subProduct: {
              guid: "4c56a86d-d487-6898-d359-069ddc48778b",
              uuid: "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
            },
            productItem: {
              guid: "0d8fc23b-591e-4211-8d80-556bb95ab9d9",
              uuid: "ef65909a-bbb2-492c-8fa4-ab217c663cdc"
            },
            volume: 4,
            unit: {
              guid: "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
              uuid: "069792f0-053d-11e1-99b4-d8d385fbc9e8"
            },
            dateOfProduction: {
              firstDate: {
                year: 2020,
                month: 12,
                day: 1
              }
            },
            expiryDate: {
              firstDate: {
                year: 2021,
                month: 12,
                day: 1
              }
            },
            perishable: false,
            lowGradeCargo: false,
            packageList: [
              {
                level: 6,
                packingType: {
                  globalID: 43,
                  name: "Мешок большой для крупноразмерных навалочных грузов",
                  guid: "933312a8-dc11-43ee-9daa-abb240bf9e3f",
                  uuid: "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                }
              },
              {
                level: 1,
                packingType: {
                  globalID: 82,
                  name: "Пакет (пачка/связка)",
                  guid: "f0b0ec9b-8341-4e95-bc0e-80898be598cb",
                  uuid: "a7363144-e6a0-4af0-832f-0d403fdeb761"
                },
                productMarks: [
                  {
                    class: 0,
                    value: "7456873456-147885"
                  }
                ]
              }
            ],
            owner: {
              guid: "7462c088-900b-24fa-fc0c-d32de8b92994",
              uuid: "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
            }
          },
          vetDocument: [
            {
              uuid: "34d4ef38-acd0-4687-82de-c9a18dd58e27"
            }
          ],
          guid: "2c00ffed-efe5-411f-a698-f66492135307",
          active: true,
          last: true,
          status: "103",
          createDate: "2017-08-07T13:22:45+03:00",
          updateDate: "2017-08-07T13:22:45+03:00",
          uuid: "8a76e66c-21c2-4574-ac72-e53ab40436ad"
        }
      ],
      count: 10,
      total: 10061,
      offset: 0,
      hasMore: false
    }
  }
}

export const DEFAULT_VET_RESULT = {
    "vetDocumentList": {
        "vetDocument": [
            {
                "vetDForm": 3,
                "vetDType": 0,
                "vetDStatus": 2,
                "certifiedConsignment": {
                    "consignor": {
                        "businessEntity": {
                            "guid": "fcd89443-218a-11e2-a69b-b499babae7ea",
                            "uuid": "04ceb142-053d-11e1-99b4-d8d385fbc9e8"
                        },
                        "enterprise": {
                            "guid": "0a69974d-85ac-4480-95f6-1e5e07267b70",
                            "uuid": "8888c36c-df2e-442f-b0d9-faef5e063b43"
                        }
                    },
                    "consignee": {
                        "businessEntity": {
                            "guid": "613f4131-6fb8-454d-af9b-a28151ef43ac",
                            "uuid": "cbee869d-5405-4181-a1d8-7e8c8af4597b"
                        },
                        "enterprise": {
                            "guid": "a2314701-c488-44ca-a444-63dfe708fb27",
                            "uuid": "1820e24c-8ac5-4985-a472-43111095166c"
                        }
                    },
                    "broker": {
                        "guid": "4277703a-7b49-455c-a2c3-3215faeca5d2",
                        "uuid": "cbee869d-5405-4181-a1d8-7e8c8af4597b"
                    },
                    "transportInfo": {
                        "transportType": 1,
                        "transportNumber": {
                            "vehicleNumber": "У121УУ"
                        }
                    },
                    "transportStorageType": 0,
                    "batch": {
                        "productType": 5,
                        "product": {
                            "guid": "d34504bb-7a93-e1c8-4859-339eafd97c6c",
                            "uuid": "31c94ff1-a217-f38d-6005-1aa5ca67e146"
                        },
                        "subProduct": {
                            "guid": "9540bfdd-4cd6-6f47-ae83-a32a36c36bfe",
                            "uuid": "a3cecd19-98ca-46f9-ecd5-90c41fd95e13"
                        },
                        "productItem": {
                            "name": "Молоко ультрапастеризованное 1,5% холостятское"
                        },
                        "volume": 300.0,
                        "unit": {
                            "guid": "21ed96c9-337b-4a27-8761-c6e6ad3c9f5b",
                            "uuid": "069792f0-053d-11e1-99b4-d8d385fbc9e8"
                        },
                        "dateOfProduction": {
                            "firstDate": {
                                "year": 2020,
                                "month": 12,
                                "day": 6
                            }
                        },
                        "expiryDate": {
                            "firstDate": {
                                "year": 2021,
                                "month": 12,
                                "day": 6
                            }
                        },
                        "perishable": false,
                        "lowGradeCargo": false,
                        "packageList": [
                            {
                                "level": 6,
                                "packingType": {
                                    "globalID": 43,
                                    "name": "Мешок большой для крупноразмерных навалочных грузов",
                                    "uuid": "118124c8-ace0-44e1-b212-ee10dd5c1cdc"
                                },
                                "quantity": "1"
                            }
                        ]
                    }
                },
                "authentication": {
                    "purpose": {
                        "guid": "5b90da1b-e089-11e1-bcf3-b499babae7ea",
                        "uuid": "b0263721-e974-40db-9153-1dc44746a788"
                    },
                    "cargoInspected": true,
                    "cargoExpertized": 6,
                    "locationProsperity": "Благополучно"
                },
                "referencedDocument": [
                    {
                        "relationshipType": 1,
                        "issueSeries": "ТТН",
                        "issueNumber": "321654987",
                        "issueDate": "2015-09-28T00:00:00",
                        "type": 2
                    }
                ],
                "statusChange": [
                    {
                        "status": 1,
                        "specifiedPerson": {
                            "fio": "Иванов Иван Иванович",
                            "phone": "1-2-3-4-5-6",
                            "post": "Врач"
                        },
                        "actualDateTime": "2017-08-07T13:22:41+03:00"
                    },
                    {
                        "status": 2,
                        "actualDateTime": "2017-08-07T13:22:41+03:00",
                        "reason": "Неверно указан объём продукции"
                    }
                ],
                "issueDate": "2017-08-07T00:00:00",
                "uuid": "bf88e2f7-5960-472d-ad8c-67578c996448"
            }
        ],
        "count": 10,
        "total": 637,
        "offset": 0,
        "hasMore": false
    }
}


export const TRANSPORT_TYPES = [
  {
    key: 1,
    value: 'Автомобильный'
  },
  {
    key: 2,
    value: 'Железнодорожный'
  },
  {
    key: 3,
    value: 'Авиатранспортный'
  },
  {
    key: 4,
    value: 'Морской (контейнер)'
  },
  {
    key: 5,
    value: 'Морской (трюм)'
  },
]

export const STORAGE_METHODS = [
  {
    key: 0,
    value: 'Замороженные'
  },
  {
    key: 1,
    value: 'Охлажденные'
  },
  {
    key: 2,
    value: 'Охлаждаемые'
  },
  {
    key: 3,
    value: 'Вентилируемые'
  },
]

// export const DEFAULT_ENTERPRISE_GUID = '9b3fef2a-ea11-4557-90c2-3a0cede16072';
export const DEFAULT_ENTERPRISE_GUID = '0a69974d-85ac-4480-95f6-1e5e07267b70';

export const WAYBILL_TYPES = [
  {
    "key": 1,
    "value": "Товарно-транспортная накладная",
    "format": "9999999999"
  },
  {
    "key": 2,
    "value": "Конасамент",
    "format": "AAA999999999"
  },
  {
    "key": 3,
    "value": "CMR",
    "format": "99999999"
  },
  {
    "key": 4,
    "value": "Авианакладная",
    "format": "999-99999999"
  },
  {
    "key": 5,
    "value": "Транспортная накладная",
    "format": "9999999999"
  },
  {
    "key": 6,
    "value": "ТОРГ-12",
    "format": "9999999999"
  },
  {
    "key": 7,
    "value": "Ветеринарное разрешение на импорт продукции на территорию ТС.",
    "format": "AA-99-999999"
  },
  {
    "key": 8,
    "value": "Разрешение ветеринарного управления субъекта РФ на ввоз продукции на территорию субъекта.",
    "format": "999999/99"
  },
  {
    "key": 9,
    "value": "Акт отбора пробы на исследование.",
    "format": "999/99"
  },
  {
    "key": 10,
    "value": "ТОРГ-13",
    "format": "9999999999"
  },
  {
    "key": 11,
    "value": "Ветеринарный сертификат на перемещение внутри РФ",
    "format": "AA-9999999"
  }
]

export const VET_DOCUMENT_ITEMS = [
  // {
  //   key: 0,
  //   value: 'Результат неизвестен'
  // },
  // {
  //   key: 1,
  //   value: 'Результат невозможно определить (не нормируется)'
  // },
  // {
  //   key: 2,
  //   value: 'Положительный результат'
  // },
  // {
  //   key: 3,
  //   value: 'Отрицательный результат'
  // },
  {
    key: 4,
    value: 'Не проводилось'
  },
  {
    key: 5,
    value: 'ВСЭ подвергнуто сырьё, из которого произведена продукция'
  },
  {
    key: 6,
    value: 'Продукция подвергнута ВСЭ в полном объеме'
  },
]

export const COUNTRY_AUTO_NUMBERS = [
  {
    "id": "93ccf520-6850-38fe-4885-dd28b3a6fbc6",
    "name": "Армения",
    "plates": [
      {"vehicle_type": 1, "format": "99-AA-99999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EK-99999"},
      {"vehicle_type": 4, "format": "AMSU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "07136d64-5821-d7cd-c46a-64f686f3db17",
    "name": "Беларусь",
    "plates": [
      {"vehicle_type": 1, "format": "9999 AA-9"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EW-99999"},
      {"vehicle_type": 4, "format": "BYMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "d90bf64b-8f06-9921-7964-97e08b7114af",
    "name": "Казахстан",
    "plates": [
      {"vehicle_type": 1, "format": "A999AA99"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "UN-99999"},
      {"vehicle_type": 4, "format": "KZMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "d13b7f26-82b6-4591-c1de-eb19e75671ea",
    "name": "Киргизия",
    "plates": [
      {"vehicle_type": 1, "format": "99 A 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EX-99999"},
      {"vehicle_type": 4, "format": "KGMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "74a3cbb1-56fa-94f3-ab3f-e8db4940d96b",
    "name": "Российская Федерация",
    "plates": [
      {"vehicle_type": 1, "format": "A999AA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "RA-99999"},
      {"vehicle_type": 4, "format": "RZMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "22e26f60-2b2b-12f2-96be-ff43d3158d1b",
    "name": "Австрия",
    "plates": [
      {"vehicle_type": 1, "format": "A 9999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OE-99999"},
      {"vehicle_type": 4, "format": "AUMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c6cd3a5f-2878-b507-bbd9-b14604b8ac4f",
    "name": "Бельгия",
    "plates": [
      {"vehicle_type": 1, "format": "AAA-999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OO-99999"},
      {"vehicle_type": 4, "format": "BEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "4b90b411-d353-76ef-32a1-01566c8808e1",
    "name": "Болгария",
    "plates": [
      {"vehicle_type": 1, "format": "A 9999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "LZ-99999"},
      {"vehicle_type": 4, "format": "BGMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "3e5a36ce-52ba-5d81-7614-01179e5436fb",
    "name": "Венгрия",
    "plates": [
      {"vehicle_type": 1, "format": "AAA-999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "HA-99999"},
      {"vehicle_type": 4, "format": "HUMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "3593e702-447f-4af8-e8b1-a9a95905c3f8",
    "name": "Германия",
    "plates": [
      {"vehicle_type": 1, "format": "A AA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "D-99999"},
      {"vehicle_type": 4, "format": "DEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "2812a1ba-7e8a-418c-43e5-1f400c3cd5db",
    "name": "Греция",
    "plates": [
      {"vehicle_type": 1, "format": "9999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "SX-99999"},
      {"vehicle_type": 4, "format": "GRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "91c5e95b-a17d-44f2-a180-bbb606229f6c",
    "name": "Дания",
    "plates": [
      {"vehicle_type": 1, "format": "AA 99 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OY-99999"},
      {"vehicle_type": 4, "format": "DKMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "00dcc230-c1ab-9f23-89a5-11bf22b0985b",
    "name": "Ирландия",
    "plates": [
      {"vehicle_type": 1, "format": "999-AAAA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EI-99999"},
      {"vehicle_type": 4, "format": "IEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c60ba9df-b186-3509-3eb0-249d33b03d30",
    "name": "Испания",
    "plates": [
      {"vehicle_type": 1, "format": "9999 AAA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EC-99999"},
      {"vehicle_type": 4, "format": "ESMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "5a443bfa-fbc7-d188-dc83-6365828eacdc",
    "name": "Италия",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "I-99999"},
      {"vehicle_type": 4, "format": "ITMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "38799e3d-16eb-0f3d-e899-021f4284f250",
    "name": "Кипр",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "5B-99999"},
      {"vehicle_type": 4, "format": "CYMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "85c23973-64bc-cef9-ac96-72ae6347eafa",
    "name": "Латвия",
    "plates": [
      {"vehicle_type": 1, "format": "AA-9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "YL-99999"},
      {"vehicle_type": 4, "format": "LVMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c79c79e2-8808-3e44-e872-bdeb2cd4cd24",
    "name": "Литва",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "LY-99999"},
      {"vehicle_type": 4, "format": "LTMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "b9290b65-be46-9be6-8771-ebad4d580e95",
    "name": "Люксембург",
    "plates": [
      {"vehicle_type": 1, "format": "AA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "LX-99999"},
      {"vehicle_type": 4, "format": "LUMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "88d45d13-9e7f-efd4-b686-7a5389595967",
    "name": "Мальта",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "9H-99999"},
      {"vehicle_type": 4, "format": "MTMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "7a56e670-eb75-2dcd-4912-81bc920b2d92",
    "name": "Нидерланды",
    "plates": [
      {"vehicle_type": 1, "format": "AA-99-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "PH-99999"},
      {"vehicle_type": 4, "format": "NLMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "19862822-4d86-18ab-5a5d-0bf802100cd9",
    "name": "Польша",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "SP-99999"},
      {"vehicle_type": 4, "format": "PLMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "43d8dec5-038b-5bb6-043b-2cf30b5df51f",
    "name": "Португалия",
    "plates": [
      {"vehicle_type": 1, "format": "AA-99-99"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "CS-99999"},
      {"vehicle_type": 4, "format": "PTMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "fbc3966c-b2cb-3c69-698b-f80e05074a08",
    "name": "Румыния",
    "plates": [
      {"vehicle_type": 1, "format": "AA 99AAA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "YR-99999"},
      {"vehicle_type": 4, "format": "ROMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "d4854ee1-9b80-14af-16fb-cf1e8fbbae00",
    "name": "Словакия",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OM-99999"},
      {"vehicle_type": 4, "format": "SKMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "36ab2a92-058c-b2cf-5fc0-5a9659c23b4e",
    "name": "Словения",
    "plates": [
      {"vehicle_type": 1, "format": "AA-999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "S5-99999"},
      {"vehicle_type": 4, "format": "SIMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "1de83f6d-5a96-41ec-f456-1413b374750b",
    "name": "Финляндия",
    "plates": [
      {"vehicle_type": 1, "format": "AAA-999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OH-99999"},
      {"vehicle_type": 4, "format": "FIMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "215ce19c-4973-3160-71b9-e93df6d8837e",
    "name": "Франция",
    "plates": [
      {"vehicle_type": 1, "format": "AA-999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "F-99999"},
      {"vehicle_type": 4, "format": "FRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "790fd011-3bf6-ce20-8e4d-a83db4793341",
    "name": "Хорватия",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "9A-99999"},
      {"vehicle_type": 4, "format": "HRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "109b19d1-becc-16d3-812b-2855de90be9c",
    "name": "Чешская Республика",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "OK-99999"},
      {"vehicle_type": 4, "format": "CZMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "a5e4141a-d06e-1ec3-faa4-7284efa7d10f",
    "name": "Швеция",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 99A"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "SE-99999"},
      {"vehicle_type": 4, "format": "SEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "2dc34c95-d55f-55cf-afbd-4db6372527b7",
    "name": "Эстония",
    "plates": [
      {"vehicle_type": 1, "format": "999 AAA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "ES-99999"},
      {"vehicle_type": 4, "format": "EEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c04b237c-c00c-af9b-92f0-9eeb76b64544",
    "name": "Абхазия",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": ""},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "3d8255f1-48eb-7932-b951-c91a1d65aead",
    "name": "Азербайджан",
    "plates": [
      {"vehicle_type": 1, "format": "99-AA-999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "4K-99999"},
      {"vehicle_type": 4, "format": "AZMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "0b0d6a33-4134-b480-cf09-a28525352fe4",
    "name": "Албания",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "ZA-99999"},
      {"vehicle_type": 4, "format": "ALMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "3d6ba798-3184-28f4-a6a1-0fa2a3aadee5",
    "name": "Андорра",
    "plates": [
      {"vehicle_type": 1, "format": "AA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "C3-99999"},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "ed1b5bfb-1039-6b74-cf35-e901f281221c",
    "name": "Босния и Герцеговина",
    "plates": [
      {"vehicle_type": 1, "format": "A-999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "T9-99999"},
      {"vehicle_type": 4, "format": "BAMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "62768b23-14c1-bde6-341e-d237d1388e44",
    "name": "Грузия",
    "plates": [
      {"vehicle_type": 1, "format": "AA-999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "4L-99999"},
      {"vehicle_type": 4, "format": "GEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "350de6be-9a32-4698-b914-0364eef812d0",
    "name": "Донецкая Народная Республика",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": ""},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "0e54a221-aa79-9dbd-2539-8707d193c922",
    "name": "Иран, Исламская Республика",
    "plates": [
      {"vehicle_type": 1, "format": "99 A 999999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EP-99999"},
      {"vehicle_type": 4, "format": "IRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "14abc6f9-0e71-7b4b-8a2e-c7a040857c7b",
    "name": "Китай",
    "plates": [
      {"vehicle_type": 1, "format": "A·A99999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "B-99999"},
      {"vehicle_type": 4, "format": "CNMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "49307750-2dfc-97ed-cdef-db0b60821cd1",
    "name": "Корея, Республика",
    "plates": [
      {"vehicle_type": 1, "format": "999AA9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "HL-99999"},
      {"vehicle_type": 4, "format": "KRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "28855830-3b88-6600-0001-b030a82f15ac",
    "name": "Лихтенштейн",
    "plates": [
      {"vehicle_type": 1, "format": "FL 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": ""},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c5fe1258-7f75-41fe-9f8b-5f01954dee24",
    "name": "Луганская Народная Республика",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": ""},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "e73fb63a-8b11-83e5-f3d9-dee3b11bc89b",
    "name": "Молдова, Республика",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "ER-99999"},
      {"vehicle_type": 4, "format": "MDMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "0b2394b5-0233-976c-77cd-fd148053559c",
    "name": "Монако",
    "plates": [
      {"vehicle_type": 1, "format": "AA 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "3A-99999"},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "b8065845-338b-6ca9-a299-96adb19e9a23",
    "name": "Монголия",
    "plates": [
      {"vehicle_type": 1, "format": "AA 99999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "JU-99999"},
      {"vehicle_type": 4, "format": "MNMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "bfda99bc-38a9-44d5-0bbe-f04e944692a1",
    "name": "Норвегия",
    "plates": [
      {"vehicle_type": 1, "format": "AA 99999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "LN-99999"},
      {"vehicle_type": 4, "format": "NOMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "b5e0dc53-37e1-5420-a92f-b972c57f77eb",
    "name": "Республика Македония",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "Z3-99999"},
      {"vehicle_type": 4, "format": "MKMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "8aaaab3c-1c1d-e392-7a9b-a87a87c80034",
    "name": "Сан-Марино",
    "plates": [
      {"vehicle_type": 1, "format": "RSM 9999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "T7-99999"},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "6711116e-b6d3-cbfa-5f0b-bc6e5dca6bf4",
    "name": "Сербия",
    "plates": [
      {"vehicle_type": 1, "format": "AA-999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "YU-99999"},
      {"vehicle_type": 4, "format": "RSMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "0dd215aa-c8d8-e3bc-323d-9d0f0bc19542",
    "name": "Соединенное Королевство",
    "plates": [
      {"vehicle_type": 1, "format": "AA99 AAA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "G-99999"},
      {"vehicle_type": 4, "format": "GBMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "cac8a802-3c65-397d-895d-c0495bf6ea61",
    "name": "Соединенные Штаты Америки",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "N-99999"},
      {"vehicle_type": 4, "format": "USMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "9190f2ab-12b8-5f0a-083a-19b7b97debc5",
    "name": "Таджикистан",
    "plates": [
      {"vehicle_type": 1, "format": "9999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EY-99999"},
      {"vehicle_type": 4, "format": "TJMM 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "46097f60-4ac4-e204-0ba1-a1cd00740e1e",
    "name": "Туркмения",
    "plates": [
      {"vehicle_type": 1, "format": "AA 99999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "EZ-99999"},
      {"vehicle_type": 4, "format": "TMMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "1806d15f-efb2-bb70-642a-102fca05de91",
    "name": "Турция",
    "plates": [
      {"vehicle_type": 1, "format": "99 AA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "TC-99999"},
      {"vehicle_type": 4, "format": "TRMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "198e41ce-5adc-b396-20cd-365bb6633bee",
    "name": "Узбекистан",
    "plates": [
      {"vehicle_type": 1, "format": "99 A 999999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "UK-99999"},
      {"vehicle_type": 4, "format": "UZMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "a03a8415-d84b-4d96-04b8-1ecf2411069f",
    "name": "Украина",
    "plates": [
      {"vehicle_type": 1, "format": "AA 9999 AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "UR-99999"},
      {"vehicle_type": 4, "format": "UAMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "af15fb9e-d815-c1b0-d8d7-d70791f836f3",
    "name": "Черногория",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999-AA"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "4O-99999"},
      {"vehicle_type": 4, "format": "MEMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "c9117f27-fdbb-7be5-909e-5900363cb962",
    "name": "Швейцария",
    "plates": [
      {"vehicle_type": 1, "format": "AA 999999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": "HB-99999"},
      {"vehicle_type": 4, "format": "CHMU 999999 9"},
      {"vehicle_type": 5, "format": ""}
    ]
  },
  {
    "id": "006d9a3b-71fa-f101-6cf9-481788b24055",
    "name": "Южная Осетия",
    "plates": [
      {"vehicle_type": 1, "format": "AAA 999"},
      {"vehicle_type": 2, "format": ""},
      {"vehicle_type": 3, "format": ""},
      {"vehicle_type": 4, "format": ""},
      {"vehicle_type": 5, "format": ""}
    ]
  }
]